// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rcti-flow-shell {
  --rcti-bg: var(--bg-primary, #f4f7f7);
  --rcti-surface: var(--surface-primary, #fff);
  --rcti-surface-muted: var(--surface-secondary, #f4f7f7);
  --rcti-border: var(--border-subtle, #dce3e2);
  --rcti-border-default: var(--border-default, #cdd6d4);
  --rcti-text: var(--text-primary, #142624);
  --rcti-muted: var(--text-secondary, #506360);
  --rcti-accent: var(--interactive-default, #0f766e);
  --rcti-info: var(--info-soft, #eff6ff);
  min-height: 100vh;
  color: var(--rcti-text);
  background: var(--rcti-bg);
  font-family: inherit;
}
.rcti-flow-main {
  min-width: 0;
  min-height: 100vh;
}
.rcti-editor-page {
  max-width: 1440px;
  margin: 0 auto;
  padding: 28px 32px 48px;
}
.rcti-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 18px;
  border: 0;
  padding: 0;
  color: var(--rcti-accent);
  background: transparent;
  font: inherit;
  cursor: pointer;
}
.rcti-page-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}
.rcti-page-heading h1 {
  margin: 0;
  color: var(--rcti-text);
  font-size: 30px;
  line-height: 1.2;
  font-weight: 650;
}
.rcti-eyebrow {
  margin: 0 0 5px;
  color: var(--rcti-muted);
  font-size: 13px;
}
.rcti-subtitle,
.rcti-business-meta {
  margin: 7px 0 0;
  color: var(--rcti-muted);
  font-size: 14px;
}
.rcti-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 9px;
}
.rcti-flow-shell .rcti-primary-button,
.rcti-flow-shell .rcti-secondary-button {
  height: 40px;
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid var(--rcti-border-default);
  border-radius: 10px;
  padding: 0 12px;
  color: var(--rcti-text);
  background: var(--rcti-surface);
  text-transform: none;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-style: normal;
  font-weight: var(--font-weight-medium, 500);
  line-height: normal;
  letter-spacing: 0;
  box-shadow: none;
}
.rcti-flow-shell .rcti-primary-button {
  border-color: var(--rcti-accent);
  color: var(--on-interactive-primary, #fff) !important;
  background: var(--rcti-accent);
  cursor: pointer;
}
.rcti-flow-shell .rcti-primary-button:hover {
  border-color: var(--interactive-pressed, #0a4a46);
  background: var(--interactive-pressed, #0a4a46);
  color: var(--on-interactive-primary, #fff) !important;
  box-shadow: none;
}
.rcti-flow-shell .rcti-primary-button:active {
  border-color: var(--interactive-pressed, #0a4a46);
  background: var(--interactive-pressed, #0a4a46);
  color: var(--on-interactive-primary, #fff) !important;
}
.rcti-flow-shell .rcti-primary-button:focus-visible {
  outline: 2px solid var(--focus-ring, #41a89e);
  outline-offset: 2px;
}
.rcti-flow-shell .rcti-primary-button.Mui-disabled {
  color: var(--text-disabled);
  background: var(--interactive-disabled);
}
.rcti-flow-shell
  :is(.rcti-primary-button, .rcti-secondary-button)
  > svg {
  width: 16px;
  height: 16px;
}
.rcti-flow-shell .rcti-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 22px;
  border: 1px solid var(--info-border, #c9dcf7);
  border-radius: 10px;
  padding: 14px 16px;
  color: var(--rcti-text);
  background: var(--rcti-info);
}
.rcti-notice > svg {
  flex: 0 0 auto;
  margin-top: 2px;
  color: var(--rcti-accent);
}
.rcti-notice div {
  display: grid;
  gap: 4px;
}
.rcti-notice span {
  color: var(--rcti-muted);
  font-size: 13px;
}
.rcti-editor-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  align-items: start;
  gap: 20px;
}
.rcti-editor-main-column {
  display: grid;
  min-width: 0;
  gap: 16px;
}
.rcti-section-card,
.rcti-summary-card {
  min-width: 0;
  border: 1px solid var(--rcti-border);
  border-radius: 12px;
  padding: 22px;
  color: var(--rcti-text);
  background: var(--rcti-surface);
}
.rcti-section-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}
.rcti-section-heading h2,
.rcti-summary-card h2 {
  margin: 0;
  color: var(--rcti-text);
  font-size: 17px;
  line-height: 1.35;
  font-weight: 650;
}
.rcti-section-heading p,
.rcti-delivery-card p {
  margin: 5px 0 0;
  color: var(--rcti-muted);
  font-size: 13px;
  line-height: 1.5;
}
.rcti-section-tag {
  border-radius: 20px;
  padding: 5px 9px;
  color: var(--rcti-muted);
  background: var(--rcti-surface-muted);
  font-size: 12px;
  white-space: nowrap;
}
.rcti-fields-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.rcti-field {
  min-width: 0;
}
.rcti-field-wide {
  grid-column: 1 / -1;
}
.rcti-field .MuiFormControl-root,
.rcti-field .MuiTextField-root {
  width: 100%;
}
.rcti-flow-shell .MuiInputBase-root {
  color: var(--rcti-text);
  background: var(--rcti-surface);
}
.rcti-flow-shell .MuiOutlinedInput-notchedOutline {
  border-color: var(--rcti-border-default);
}
.rcti-flow-shell .MuiInputLabel-root {
  color: var(--rcti-muted);
}
.rcti-field-error {
  margin: 5px 0 0;
  color: var(--danger-text, #a3301f);
  font-size: 12px;
}
.rcti-table-wrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--rcti-border);
  border-radius: 8px;
}
.rcti-table-wrap > div {
  min-width: 690px;
}
.rcti-totals-grid {
  margin-top: 18px;
}
.rcti-total-field {
  grid-column: span 2;
}
.rcti-upload-hint {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px dashed var(--rcti-border-default);
  border-radius: 8px;
  padding: 16px;
  color: var(--rcti-muted);
  font-size: 13px;
}
.rcti-upload-hint svg {
  color: var(--rcti-accent);
}
.rcti-editor-aside {
  position: sticky;
  top: 82px;
  display: grid;
  gap: 14px;
}
.rcti-summary-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rcti-summary-title svg {
  color: var(--rcti-accent);
}
.rcti-summary-card > strong {
  display: block;
  margin-top: 20px;
  color: var(--rcti-text);
  font-size: 27px;
  font-weight: 650;
}
.rcti-summary-card > span {
  display: block;
  margin-top: 3px;
  color: var(--rcti-muted);
  font-size: 13px;
}
.rcti-summary-card hr {
  height: 1px;
  margin: 18px 0;
  border: 0;
  background: var(--rcti-border);
}
.rcti-summary-card dl {
  display: grid;
  gap: 13px;
  margin: 0;
}
.rcti-summary-card dl div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}
.rcti-summary-card dt {
  color: var(--rcti-muted);
}
.rcti-summary-card dd {
  max-width: 58%;
  margin: 0;
  color: var(--rcti-text);
  text-align: right;
  overflow-wrap: anywhere;
}
.rcti-delivery-card p {
  margin-top: 10px;
}
.rcti-mobile-actions {
  display: none;
}
@media (max-width: 1100px) {
  .rcti-editor-page {
    padding: 22px 20px 40px;
  }
  .rcti-editor-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-editor-aside {
    position: static;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .rcti-summary-card > strong {
    font-size: 23px;
  }
}
@media (max-width: 700px) {
  .rcti-editor-page {
    padding: 18px 14px 30px;
  }
  .rcti-page-heading {
    display: block;
  }
  .rcti-page-heading h1 {
    font-size: 25px;
  }
  .rcti-header-actions {
    display: none;
  }
  .rcti-fields-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
  }
  .rcti-field-wide,
  .rcti-total-field {
    grid-column: auto;
  }
  .rcti-section-card,
  .rcti-summary-card {
    padding: 16px;
    border-radius: 10px;
  }
  .rcti-section-heading {
    margin-bottom: 14px;
  }
  .rcti-section-heading h2,
  .rcti-summary-card h2 {
    font-size: 16px;
  }
  .rcti-editor-aside {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-mobile-actions {
    position: sticky;
    bottom: 0;
    z-index: 3;
    display: flex;
    gap: 8px;
    margin: 18px -14px -30px;
    border-top: 1px solid var(--rcti-border);
    padding: 10px 14px;
    background: var(--rcti-surface);
  }
  .rcti-mobile-actions > button {
    flex: 1 1;
    min-width: 0;
    padding: 8px;
    font-size: 12px;
  }
}
/* RCTI register page */
.rcti-list-page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.rcti-mobile-organisation {
  display: none;
}
.rcti-list-heading {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 12px 20px;
}
.rcti-list-heading h1 {
  margin: 0;
  color: var(--rcti-text);
  font-size: 30px;
  line-height: 1.2;
  font-weight: 650;
}
.rcti-list-heading > div:first-child > p {
  margin: 7px 0 0;
  color: var(--rcti-muted);
  font-size: 14px;
}
.rcti-list-heading > .rcti-primary-button {
  grid-column: 2;
  grid-row: 1;
}
.rcti-list-context {
  grid-column: 1 / -1;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  color: var(--rcti-muted);
  font-size: 13px;
}
.rcti-financial-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 24px;
  margin-top: 0;
}
.rcti-financial-card {
  min-width: 0;
  min-height: 154px;
  border: 1px solid var(--rcti-border);
  border-radius: 14px;
  padding: 24px;
  background: var(--rcti-surface);
}
.rcti-financial-card > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}
.rcti-financial-card h2 {
  margin: 0;
  color: var(--rcti-text);
  font-size: 17px;
  font-weight: 600;
}
.rcti-financial-card svg {
  width: 20px;
  height: 20px;
  color: var(--rcti-accent);
}
.rcti-financial-card > strong {
  display: block;
  margin-top: 24px;
  color: var(--rcti-text);
  font: 700 23px/1.2 var(--font-family-mono, "JetBrains Mono", monospace);
}
.rcti-financial-card > p {
  margin: 8px 0 0;
  color: var(--rcti-muted);
  font-size: 13px;
}
.rcti-summary-note {
  grid-column: 1 / -1;
  margin: 0;
  color: var(--rcti-muted);
  font-size: 13px;
}
.rcti-filters {
  margin-top: 0;
}
.rcti-status-tabs {
  display: flex;
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  border-bottom: 1px solid var(--rcti-border);
  scrollbar-width: thin;
}
.rcti-status-tabs button {
  flex: 0 0 auto;
  min-height: 42px;
  border: 0;
  border-bottom: 2px solid transparent;
  padding: 10px 16px;
  color: var(--rcti-muted);
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s ease;
}
.rcti-status-tabs button:hover {
  color: var(--text-secondary, #506360);
  background: transparent;
  box-shadow: none;
}
.rcti-status-tabs button.is-active {
  border-bottom-color: var(--rcti-accent);
  color: var(--rcti-accent);
}
.rcti-list-filter-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}
.rcti-list-search {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(420px, 40%);
  height: 40px;
  border: 1px solid var(--rcti-border-default);
  border-radius: 10px;
  padding: 0 12px;
  color: var(--rcti-muted);
  background: var(--rcti-surface);
}
.rcti-list-search > svg {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
}
.rcti-list-search:focus-within {
  border: 2px solid var(--interactive-default, #0f766e);
  padding-inline: 11px;
  box-shadow: var(--field-focus-ring, 0 0 0 3px rgba(15, 186, 196, 0.22));
}
.rcti-list-search input {
  min-width: 0;
  width: 100%;
  border: 0;
  outline: 0;
  color: var(--rcti-text);
  background: transparent;
  font: inherit;
  font-size: 14px;
}
.rcti-list-search input::placeholder {
  color: var(--text-disabled);
  opacity: 1;
}
.rcti-list-search button {
  display: none;
  border: 0;
  color: var(--rcti-accent);
  background: transparent;
}
.rcti-filter-select {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  border: 1px solid var(--rcti-border-default);
  border-radius: 10px;
  padding: 0 12px;
  background: var(--rcti-surface);
}
.rcti-filter-select select {
  width: 100%;
  min-width: 100px;
  appearance: none;
  border: 0;
  outline: 0;
  padding-right: 22px;
  color: var(--rcti-text);
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.rcti-filter-select > svg {
  position: absolute;
  right: 10px;
  width: 16px;
  height: 16px;
  color: var(--rcti-muted);
  pointer-events: none;
}
.rcti-due-select select {
  min-width: 144px;
}
.rcti-flow-shell .rcti-refresh-button {
  display: none;
  min-width: 40px;
  height: 40px;
  border: 1px solid var(--rcti-border-default);
  border-radius: 10px;
  color: var(--rcti-muted);
  background: var(--rcti-surface);
}
.rcti-date-hint {
  margin: 10px 0 0;
  color: var(--rcti-muted);
  font-size: 13px;
}
.rcti-register-card {
  margin-top: 0;
  overflow: hidden;
  border: 1px solid var(--rcti-border);
  border-radius: 14px;
  background: var(--rcti-surface);
  box-shadow: 0 1px 2px rgb(14 26 32 / 6%);
}
.rcti-register-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 50px;
  gap: 12px;
  padding: 0;
  color: var(--rcti-text);
  font-size: 13px;
}
.rcti-register-heading span {
  color: var(--rcti-muted);
  font-weight: 400;
}
.rcti-register-table .rdt_Table {
  color: var(--rcti-text);
  background: var(--rcti-surface);
}
.rcti-register-table .rdt_TableHeadRow {
  background: var(--rcti-surface-muted);
}
.rcti-register-table .rdt_TableCol,
.rcti-register-table .rdt_TableCell {
  overflow: visible;
}
.rcti-register-table .rdt_TableCol_Sortable {
  color: var(--rcti-muted);
}
.rcti-register-table .rdt_TableRow {
  border-bottom-color: var(--rcti-border) !important;
}
.rcti-register-table .rdt_TableRow:hover {
  background: var(--rcti-surface-muted) !important;
}
.rcti-register-number {
  color: var(--rcti-accent);
  text-decoration: none;
  font: 500 14px/1.4 var(--font-family-mono, "JetBrains Mono", monospace);
}
.rcti-register-number:hover {
  text-decoration: underline;
}
.rcti-register-supplier {
  color: var(--rcti-text);
}
.rcti-register-money {
  color: var(--rcti-text);
  font: 500 16px/1.4 var(--font-family-mono, "JetBrains Mono", monospace);
  white-space: nowrap;
}
.rcti-status-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.rcti-status-pill {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  white-space: nowrap;
}
.rcti-status-overdue-payable {
  color: var(--danger-text, #a3301f);
  background: var(--danger-soft, #fef2f1);
}
.rcti-status-payment-due {
  color: var(--warning-text, #7d4412);
  background: var(--warning-soft, #fef8ec);
}
.rcti-status-draft,
.rcti-status-voided {
  color: var(--text-secondary);
  background: var(--surface-tertiary);
}
.rcti-status-paid {
  color: var(--success-text, #115a33);
  background: var(--success-soft, #edfbf2);
}
.rcti-status-meta {
  max-width: 150px;
  color: var(--rcti-muted);
  font-size: 12px;
  line-height: 16px;
  white-space: normal;
}
.rcti-mobile-register,
.rcti-tablet-columns {
  display: none;
}
.rcti-list-empty {
  display: flex;
  min-height: 260px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: var(--rcti-muted);
  text-align: center;
}
.rcti-list-empty svg {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
  color: var(--rcti-accent);
}
.rcti-list-empty strong {
  color: var(--rcti-text);
  font-size: 15px;
}
.rcti-list-empty span {
  font-size: 13px;
}
.rcti-list-empty button {
  display: inline-flex;
  height: 40px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 6px;
  padding: 0 12px;
  border: 1px solid var(--rcti-accent);
  border-radius: 10px;
  background: var(--rcti-surface);
  color: var(--rcti-accent);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-style: normal;
  font-weight: var(--font-weight-medium, 500);
  line-height: normal;
  letter-spacing: 0;
  cursor: pointer;
}
.rcti-list-empty button:hover {
  border-color: var(--interactive-pressed, #0a4a46);
  background: var(--interactive-pressed, #0a4a46);
  color: var(--on-interactive-primary, #fff);
}
.rcti-list-empty button > svg {
  width: 16px;
  height: 16px;
}
.rcti-list-empty button:focus-visible {
  outline: 2px solid var(--focus-ring, #41a89e);
  outline-offset: 2px;
}
.rcti-register-footer {
  display: flex;
  min-height: 50px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid var(--rcti-border);
  padding: 0 16px;
  color: var(--rcti-muted);
  font-size: 12px;
}
.rcti-register-footer > div {
  display: flex;
  gap: 8px;
}
.rcti-register-footer button {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--rcti-border);
  border-radius: 8px;
  color: var(--rcti-muted);
  background: var(--rcti-surface);
  font-size: 20px;
  cursor: pointer;
}
.rcti-register-footer button:disabled {
  opacity: 0.45;
  cursor: default;
}
.rcti-mobile-card-top {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.rcti-mobile-card-top .MuiCheckbox-root {
  margin-left: -8px;
  padding: 4px;
  color: var(--border-strong);
}
.rcti-mobile-supplier {
  min-width: 0;
  overflow: hidden;
  color: var(--rcti-text);
  font-size: 14px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rcti-mobile-actions-menu {
  margin-left: auto;
}
.rcti-mobile-document {
  color: var(--rcti-muted);
  font-size: 12px;
}
.rcti-mobile-financials {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}
.rcti-mobile-financials > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}
.rcti-mobile-financials small {
  color: var(--rcti-muted);
  font-size: 11px;
}
.rcti-mobile-financials span,
.rcti-mobile-financials strong {
  color: var(--rcti-text);
  font-size: 12px;
  font-weight: 500;
  overflow-wrap: anywhere;
}
.rcti-mobile-financials strong {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
}
.rcti-mobile-delivery {
  margin: 8px 0 0;
  color: var(--rcti-muted);
  font-size: 11px;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}
@media (max-width: 1100px) {
  .rcti-list-page {
    padding: 20px 24px 36px;
  }
  .rcti-mobile-organisation {
    display: flex;
    min-height: 54px;
    align-items: center;
    gap: 10px;
    margin-bottom: 18px;
    border: 1px solid var(--rcti-border);
    border-radius: 10px;
    padding: 8px 12px;
    background: var(--rcti-surface);
  }
  .rcti-mobile-organisation {
    max-width: 240px;
    margin-left: auto;
  }
  .rcti-organisation-avatar {
    display: grid;
    width: 32px;
    height: 32px;
    place-items: center;
    border: 1px solid var(--rcti-border);
    border-radius: 50%;
    color: var(--rcti-accent);
    font-size: 10px;
    font-weight: 600;
  }
  .rcti-mobile-organisation > span:nth-child(2) {
    display: grid;
    flex: 1 1;
    gap: 2px;
  }
  .rcti-mobile-organisation strong {
    color: var(--rcti-text);
    font-size: 13px;
    font-weight: 500;
  }
  .rcti-mobile-organisation small {
    color: var(--rcti-muted);
    font-size: 11px;
  }
  .rcti-mobile-organisation > svg {
    width: 16px;
    height: 16px;
    color: var(--rcti-accent);
  }
  .rcti-financial-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-top: 20px;
  }
  .rcti-financial-card:nth-child(3) {
    grid-column: 1 / -1;
  }
  .rcti-financial-card {
    min-height: 122px;
    padding: 16px;
  }
  .rcti-financial-card > strong {
    margin-top: 14px;
    font-size: 19px;
  }
  .rcti-financial-card h2 {
    font-size: 14px;
  }
  .rcti-financial-card > p {
    margin-top: 6px;
    font-size: 11px;
  }
  .rcti-filters {
    margin-top: 12px;
  }
  .rcti-list-filter-row {
    flex-wrap: wrap;
  }
  .rcti-list-search {
    flex: 1 1 100%;
    width: 100%;
  }
  .rcti-filter-select {
    flex: 0 1 auto;
  }
  .rcti-register-table {
    display: none;
  }
  .rcti-mobile-register {
    display: block;
  }
  .rcti-tablet-columns {
    display: grid;
    grid-template-columns:
      28px minmax(0, 1.2fr) minmax(120px, 0.9fr) minmax(130px, 1fr)
      40px;
    align-items: center;
    min-height: 40px;
    border-block: 1px solid var(--rcti-border);
    padding: 0 12px;
    color: var(--rcti-muted);
    background: var(--rcti-surface-muted);
    font-size: 11px;
    font-weight: 500;
  }
  .rcti-register-mobile-card {
    display: grid;
    grid-template-columns:
      28px minmax(0, 1.2fr) minmax(120px, 0.9fr) minmax(130px, 1fr)
      40px;
    align-items: center;
    min-height: 84px;
    gap: 3px 0;
    border-bottom: 1px solid var(--rcti-border);
    padding: 8px 12px;
    background: var(--rcti-surface);
  }
  .rcti-mobile-card-top {
    display: contents;
  }
  .rcti-mobile-card-top .MuiCheckbox-root {
    grid-column: 1;
    grid-row: 1 / span 3;
    margin-left: -6px;
  }
  .rcti-mobile-supplier {
    grid-column: 2;
    grid-row: 1;
    font-size: 12px;
  }
  .rcti-mobile-card-top > .rcti-status-pill {
    grid-column: 3;
    grid-row: 1;
    justify-self: start;
  }
  .rcti-mobile-actions-menu {
    grid-column: 5;
    grid-row: 1 / span 2;
    justify-self: center;
    margin: 0;
  }
  .rcti-register-mobile-card > .rcti-register-number {
    grid-column: 2;
    grid-row: 2;
    font-size: 12px;
  }
  .rcti-mobile-document {
    grid-column: 2;
    grid-row: 3;
    font-size: 10px;
  }
  .rcti-mobile-financials {
    display: contents;
  }
  .rcti-mobile-financials > div:first-child {
    grid-column: 3;
    grid-row: 2 / span 2;
  }
  .rcti-mobile-financials > div:nth-child(2) {
    grid-column: 4;
    grid-row: 1 / span 2;
  }
  .rcti-mobile-financials > div:nth-child(3) {
    grid-column: 4;
    grid-row: 3;
  }
  .rcti-mobile-financials small {
    font-size: 10px;
  }
  .rcti-mobile-financials span,
  .rcti-mobile-financials strong {
    font-size: 11px;
  }
  .rcti-mobile-delivery {
    grid-column: 3;
    grid-row: 4;
    font-size: 10px;
  }
  .rcti-status-meta {
    display: none;
  }
  .rcti-register-footer {
    min-height: 48px;
  }
  .rcti-date-hint {
    margin-top: 8px;
    font-size: 11px;
  }
}
@media (max-width: 600px) {
  .rcti-list-page {
    padding: 16px 16px 28px;
  }
  .rcti-mobile-organisation {
    max-width: none;
    margin: 0 0 16px;
  }
  .rcti-list-heading {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .rcti-list-heading h1 {
    font-size: 24px;
  }
  .rcti-list-heading > .rcti-primary-button {
    grid-column: 1;
    grid-row: 2;
    width: 100%;
  }
  .rcti-list-context {
    grid-column: 1;
    flex-direction: column;
    gap: 4px;
    margin-top: 4px;
    font-size: 12px;
  }
  .rcti-financial-summary {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
    margin-top: 18px;
  }
  .rcti-financial-card:nth-child(3) {
    grid-column: auto;
  }
  .rcti-financial-card {
    min-height: 122px;
    padding: 16px;
  }
  .rcti-financial-card > strong {
    margin-top: 14px;
  }
  .rcti-summary-note {
    font-size: 11px;
    line-height: 1.5;
  }
  .rcti-status-tabs button {
    min-height: 40px;
    padding: 9px 11px;
    font-size: 11px;
  }
  .rcti-list-filter-row {
    gap: 8px;
  }
  .rcti-list-search {
    height: 40px;
  }
  .rcti-list-search button {
    display: block;
    flex: 0 0 auto;
    padding: 2px;
  }
  .rcti-list-search button svg {
    width: 16px;
    height: 16px;
  }
  .rcti-filter-select {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 4px);
    min-width: 0;
    height: 38px;
    padding-inline: 10px;
  }
  .rcti-filter-select select,
  .rcti-due-select select {
    min-width: 0;
    width: 100%;
    font-size: 11px;
  }
  .rcti-flow-shell .rcti-refresh-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 38px;
    width: 38px;
    height: 38px;
    padding: 0;
  }
  .rcti-date-hint {
    font-size: 10px;
  }
  .rcti-table-card {
    margin-top: 16px;
    border-radius: 10px;
  }
  .rcti-table-card .quotation-table-context {
    height: 44px;
    padding-inline: 12px;
  }
  .rcti-table-card .quotation-table-context strong {
    font-size: 12px;
  }
  .rcti-table-card .quotation-table-context span {
    display: none;
  }
  .rcti-tablet-columns {
    display: none;
  }
  .rcti-register-mobile-card {
    display: block;
    min-height: 0;
    padding: 14px 12px;
  }
  .rcti-mobile-card-top {
    display: flex;
    gap: 7px;
  }
  .rcti-mobile-card-top .MuiCheckbox-root {
    margin-left: -6px;
  }
  .rcti-mobile-supplier {
    flex: 1 1;
    font-size: 13px;
  }
  .rcti-mobile-card-top > .rcti-status-pill {
    align-self: center;
  }
  .rcti-mobile-actions-menu {
    margin-left: 0;
  }
  .rcti-register-mobile-card > .rcti-register-number {
    display: inline-block;
    margin: 7px 0 5px 32px;
    font-size: 12px;
  }
  .rcti-mobile-document {
    margin-left: 32px;
    font-size: 11px;
  }
  .rcti-mobile-financials {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin: 12px 0 0 32px;
  }
  .rcti-mobile-financials > div:first-child {
    grid-column: 1 / -1;
  }
  .rcti-mobile-financials > div:nth-child(2),
  .rcti-mobile-financials > div:nth-child(3) {
    grid-column: auto;
  }
  .rcti-mobile-financials small {
    font-size: 10px;
  }
  .rcti-mobile-financials span,
  .rcti-mobile-financials strong {
    font-size: 12px;
  }
  .rcti-mobile-delivery {
    margin: 8px 0 0 32px;
  }
  .rcti-table-card .quotation-pagination {
    height: 44px;
    padding-inline: 12px;
  }
  .rcti-table-card .quotation-pagination span {
    font-size: 10px;
  }
  .rcti-table-card .quotation-pagination-btns {
    gap: 6px;
  }
  .rcti-table-card .quotation-pagination-btns button {
    width: 30px;
    height: 30px;
  }
}
/* RCTI editor responsive details */
.rcti-flow-shell {
  --dn-surface: var(--rcti-surface);
  --dn-border: var(--rcti-border);
  --dn-border-strong: var(--rcti-border-default);
  --dn-text: var(--rcti-text);
  --dn-muted: var(--rcti-muted);
  --dn-brand: var(--rcti-accent);
  --dn-brand-soft: var(--interactive-soft, #f0f8f7);
}
.rcti-mobile-editor-actions {
  display: none;
}
.rcti-editor-state {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 9px;
  color: var(--rcti-muted);
  font-size: 13px;
}
.rcti-editor-state-pill {
  border-radius: 999px;
  padding: 3px 9px;
  color: var(--rcti-muted);
  background: var(--rcti-surface-muted);
  font-size: 12px;
}
.rcti-draft-total {
  display: none;
}
.rcti-form-hint {
  grid-column: 1 / -1;
  margin: -4px 0 0;
  color: var(--rcti-muted);
  font-size: 12px;
  line-height: 1.5;
}
.rcti-notes-field {
  margin-top: 16px !important;
}
.rcti-desktop-items {
  display: block;
}
.rcti-editable-items {
  display: none;
}
.rcti-item-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}
.rcti-financial-breakdown {
  display: grid;
  gap: 12px;
  margin-top: 20px;
  border-top: 1px solid var(--rcti-border);
  padding-top: 18px;
}
.rcti-financial-breakdown > div {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  color: var(--rcti-muted);
  font-size: 13px;
}
.rcti-financial-breakdown strong {
  color: var(--rcti-text);
  font: 500 13px/1.5 var(--font-family-mono, "JetBrains Mono", monospace);
  text-align: right;
}
.rcti-financial-breakdown .rcti-final-total {
  border-top: 1px solid var(--rcti-border);
  padding-top: 12px;
  color: var(--rcti-text);
  font-weight: 600;
}
.rcti-financial-breakdown .rcti-final-total strong {
  font-weight: 700;
}
.rcti-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(10, 16, 16, 0.45);
}
.rcti-leave-dialog {
  position: relative;
  width: min(100%, 480px);
  border: 1px solid var(--rcti-border);
  border-radius: 14px;
  padding: 24px;
  color: var(--rcti-text);
  background: var(--rcti-surface);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
}
.rcti-leave-dialog h2 {
  margin: 0;
  font-size: 20px;
}
.rcti-leave-dialog p {
  margin: 10px 0 20px;
  color: var(--rcti-muted);
  font-size: 14px;
  line-height: 1.5;
}
.rcti-leave-dialog > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}
.rcti-dialog-close {
  position: absolute;
  top: 12px;
  right: 12px;
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 0;
  border-radius: 8px;
  color: var(--rcti-muted);
  background: transparent;
  cursor: pointer;
}
.rcti-dialog-close:hover {
  background: var(--rcti-surface-muted);
}
@media (max-width: 1100px) {
  .rcti-editor-page .debit-tablet-nav {
    margin: 0 0 20px;
  }
  .rcti-editor-page {
    padding-top: 22px;
  }
  .rcti-editor-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-editor-aside {
    position: static;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .rcti-summary-card > strong {
    font-size: 23px;
  }
  .rcti-draft-total {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: -6px 0 18px;
    border: 1px solid var(--rcti-border);
    border-radius: 10px;
    padding: 12px 16px;
    color: var(--rcti-muted);
    background: var(--rcti-surface);
    font-size: 13px;
  }
  .rcti-draft-total strong {
    margin-left: auto;
    color: var(--rcti-text);
    font: 600 15px/1.4 var(--font-family-mono, "JetBrains Mono", monospace);
  }
  .rcti-draft-total small {
    color: var(--rcti-muted);
  }
  .rcti-mobile-editor-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin: -6px 0 18px;
  }
  .rcti-mobile-editor-actions > button:last-child {
    grid-column: 1 / -1;
  }
  .rcti-header-actions {
    display: none;
  }
  .rcti-desktop-items {
    display: none;
  }
  .rcti-editable-items {
    display: grid;
    gap: 12px;
  }
  .rcti-editable-item {
    min-width: 0;
    border: 1px solid var(--rcti-border);
    border-radius: 10px;
    padding: 14px;
    background: var(--rcti-surface);
  }
  .rcti-editable-item-heading {
    display: flex;
    min-height: 28px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--rcti-border);
    padding-bottom: 8px;
    color: var(--rcti-text);
    font-size: 13px;
  }
  .rcti-editable-item-heading .MuiGrid-container {
    width: auto;
    margin: 0;
  }
  .rcti-editable-item-fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    padding-top: 12px;
  }
  .rcti-editable-item-fields > div {
    min-width: 0;
  }
  .rcti-editable-item-fields > div > span {
    display: block;
    margin-bottom: 4px;
    color: var(--rcti-muted);
    font-size: 11px;
  }
  .rcti-editable-item-fields .MuiInputBase-root {
    width: 100% !important;
    min-width: 0 !important;
  }
  .rcti-editable-item-fields .MuiGrid-container,
  .rcti-editable-item-fields .MuiGrid-item {
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
  }
  .rcti-editable-item-fields .MuiInputBase-input {
    box-sizing: border-box;
    min-width: 0 !important;
  }
  .rcti-editable-item-fields > div:first-child,
  .rcti-editable-item-fields > div:nth-child(2) {
    grid-column: 1 / -1;
  }
  .rcti-list-shell .debit-tablet-nav {
    margin: 0 32px;
  }
  .rcti-list-page {
    padding-top: 24px;
    gap: 20px;
  }
}
@media (max-width: 700px) {
  .rcti-editor-page .debit-tablet-nav {
    margin: 0 0 14px;
  }
  .rcti-editor-page {
    padding-top: 18px;
  }
  .rcti-draft-total {
    flex-wrap: wrap;
    gap: 6px 10px;
    padding: 10px 12px;
  }
  .rcti-draft-total span {
    flex: 1 1 100%;
  }
  .rcti-draft-total strong {
    margin-left: 0;
  }
  .rcti-mobile-editor-actions {
    grid-template-columns: 1fr 1fr;
  }
  .rcti-mobile-editor-actions > button {
    min-width: 0;
    padding-inline: 8px;
    font-size: 12px;
  }
  .rcti-editor-aside {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-editable-item-fields {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-editable-item-fields > div:first-child,
  .rcti-editable-item-fields > div:nth-child(2) {
    grid-column: auto;
  }
  .rcti-list-shell .debit-tablet-nav {
    margin: 0 16px;
  }
  .rcti-list-page {
    padding-top: 16px;
    gap: 16px;
  }
  .rcti-leave-dialog {
    padding: 22px 16px 16px;
  }
  .rcti-leave-dialog > div {
    justify-content: stretch;
  }
  .rcti-leave-dialog > div > button {
    flex: 1 1 auto;
  }
}
/* Desktop listing refinements from Figma 1261:68924 */
.rcti-list-heading h1 {
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.48px;
  font-weight: 600;
}
.rcti-list-heading > div:first-child > p {
  margin-top: 4px;
  line-height: 21.7px;
}
.rcti-list-context {
  margin-top: 0;
  line-height: 19px;
}
.rcti-financial-card {
  min-height: 154px;
}
.rcti-financial-card h2 {
  font-size: 16px;
  line-height: 22.4px;
  font-weight: 500;
  letter-spacing: -0.08px;
}
.rcti-financial-card > strong {
  font-size: 20px;
  line-height: 24px;
}
.rcti-financial-card > p,
.rcti-summary-note {
  font-size: 13px;
  line-height: 18.2px;
}
.rcti-list-search {
  flex: 0 0 420px;
  width: 420px;
}
.rcti-filter-select {
  flex: 0 0 126px;
  width: 126px;
}
.rcti-filter-select select {
  min-width: 0;
  font-size: 13px;
}
.rcti-due-select {
  flex-basis: 169px;
  width: 169px;
}
.rcti-due-select select {
  min-width: 0;
}
.rcti-register-table .rdt_TableCol--selectable,
.rcti-register-table .rdt_TableCell--selectable {
  flex: 0 0 40px !important;
  width: 40px !important;
  min-width: 40px !important;
}
.rcti-register-table .rdt_TableHeadRow {
  min-height: 44px;
}
.rcti-register-table .rdt_TableCol {
  font-size: 13px;
}
.rcti-register-table .rdt_TableCell {
  font-size: 14px;
}
.rcti-status-overdue,
.rcti-status-overdue-payable {
  color: var(--danger-text, #a3301f);
  background: var(--danger-soft, #fef2f1);
}
.rcti-planned-date {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 18px;
}
.rcti-planned-date small {
  color: var(--rcti-muted);
  font-size: 12px;
}
.rcti-table-card {
  margin-top: 0;
  overflow: visible;
}
.rcti-table-card .quotation-table-context {
  min-height: 48px;
}
.rcti-table-card .quotation-table-scroll {
  overflow-x: auto;
}
.rcti-table-card table {
  min-width: 1120px;
  table-layout: auto;
}
.rcti-table-card th {
  padding-inline: 16px;
  font-size: 13px;
  text-align: left;
}
.rcti-table-card td {
  padding: 8px 16px;
  text-align: left;
}
.rcti-table-card th.rcti-col-select,
.rcti-table-card td.rcti-col-select {
  width: 48px;
  padding: 0;
  text-align: center;
}
.rcti-table-card th.rcti-col-actions,
.rcti-table-card td.rcti-col-actions {
  padding-inline: 16px;
  text-align: right;
}
.rcti-table-card th.rcti-heading-money {
  text-align: right;
}
.rcti-table-card .rcti-table-supplier {
  max-width: 28ch;
  white-space: normal;
  overflow-wrap: anywhere;
}
.rcti-table-card .rcti-table-money {
  text-align: right;
}
.rcti-sort-heading {
  border: 0;
  padding: 0;
  color: inherit;
  background: transparent;
  font: inherit;
  text-align: inherit;
  cursor: pointer;
}
.rcti-sort-heading:focus-visible {
  outline: 2px solid var(--interactive-default);
  outline-offset: 3px;
  border-radius: 2px;
}
.rcti-row-actions {
  position: relative;
  display: flex;
  justify-content: center;
}
.rcti-table-card .rcti-col-actions .rcti-row-actions {
  justify-content: flex-end;
}
.rcti-row-actions .quotation-action-menu {
  top: calc(100% + 4px);
  right: 0;
  z-index: 20;
}
.rcti-planned-date {
  display: flex;
  flex-direction: column;
  gap: 1px;
  line-height: 17px;
}
.rcti-planned-date small {
  font-size: 11px;
}
.rcti-table-card .quotation-pagination {
  flex: 0 0 52px;
}
.rcti-table-card .rcti-register-table .rcti-status-pill {
  min-height: 20px;
  padding-inline: 8px;
}
.rcti-flow-shell.dark .rcti-table-card .quotation-table-card,
.rcti-flow-shell.dark .rcti-table-card .quotation-pagination {
  color: var(--rcti-text);
}
.rcti-flow-shell.dark .rcti-table-card .quotation-action-menu {
  border-color: var(--border-default, #3a3f47);
  background: var(--surface-elevated, #25282e);
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.35), 0px 1px 2px rgba(0, 0, 0, 0.2);
}
.rcti-table-card tbody tr,
.rcti-register-mobile-card {
  cursor: pointer;
}
.rcti-table-card tbody tr:hover,
.rcti-register-mobile-card:hover {
  background: var(--rcti-surface-muted);
}
.rcti-contact-link {
  color: var(--rcti-accent);
  font: inherit;
  text-decoration: none;
  text-underline-offset: 2px;
}
.rcti-contact-link:hover {
  text-decoration: underline;
  color: #0f766e;
}
.rcti-contact-link:focus-visible {
  border-radius: 2px;
  outline: 2px solid var(--rcti-accent);
  outline-offset: 2px;
}
.rcti-flow-shell.dark .rcti-table-card .quotation-menu-item {
  color: var(--rcti-text);
}
.rcti-flow-shell.dark .rcti-table-card .quotation-menu-item:hover {
  background: var(--surface-secondary);
}
@media (max-width: 600px) {
  .rcti-table-card {
    margin-top: 16px;
    border-radius: 10px;
  }
  .rcti-table-card .quotation-table-context {
    height: 44px;
    padding-inline: 12px;
  }
  .rcti-table-card .quotation-table-context strong {
    font-size: 12px;
  }
  .rcti-table-card .quotation-table-context span {
    display: none;
  }
  .rcti-table-card .quotation-pagination {
    height: 44px;
    padding-inline: 12px;
  }
  .rcti-table-card .quotation-pagination span {
    font-size: 10px;
  }
  .rcti-table-card .quotation-pagination-btns {
    gap: 6px;
  }
  .rcti-table-card .quotation-pagination-btns button {
    width: 30px;
    height: 30px;
  }
}
@media (max-width: 1100px) {
  .rcti-list-heading h1 {
    font-size: 28px;
    line-height: 35px;
    letter-spacing: -0.42px;
  }
  .rcti-list-search {
    flex: 1 1 100%;
    width: 100%;
  }
  .rcti-filter-select,
  .rcti-due-select {
    flex: 0 1 auto;
    width: auto;
  }
}

/* RCTI editor geometry and responsive variants from Figma 1261:70442–70970. */
.rcti-editor-page {
  padding: 32px 32px 48px;
}
.rcti-editor-page .rcti-back {
  margin-bottom: 16px;
}
.rcti-editor-page .rcti-page-heading {
  margin-bottom: 0;
}
.rcti-editor-page .rcti-page-heading h1 {
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.36px;
  font-weight: 600;
}
.rcti-editor-page .rcti-business-meta {
  margin: 16px 0 0;
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.rcti-editor-page .rcti-notice {
  margin: 16px 0 24px;
  border: 0;
  border-radius: 10px;
  padding: 16px;
  background: var(--surface-secondary, #f4f7f7);
}
.rcti-editor-page .rcti-notice > div {
  gap: 4px;
}
.rcti-editor-page .rcti-notice strong {
  font-size: 13px;
  line-height: 16.9px;
  font-weight: 500;
}
.rcti-editor-page .rcti-notice span {
  font-size: 13px;
  line-height: 18.2px;
}
.rcti-editor-layout {
  grid-template-columns: minmax(0, 776fr) minmax(280px, 320fr);
  gap: 24px;
}
.rcti-editor-main-column {
  gap: 24px;
}
.rcti-editor-page .rcti-editor-aside {
  gap: 24px;
}
.rcti-editor-page .rcti-section-card,
.rcti-editor-page .rcti-summary-card {
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 1px 2px rgb(14 26 32 / 6%);
}
.rcti-editor-page .rcti-section-heading h2,
.rcti-editor-page .rcti-summary-card h2 {
  font-size: 16px;
  line-height: 22.4px;
  letter-spacing: -0.08px;
  font-weight: 500;
}
.rcti-editor-page .rcti-section-heading {
  margin-bottom: 24px;
}
.rcti-editor-page .rcti-section-heading:has(p) {
  margin-bottom: 20px;
}
.rcti-editor-page .rcti-section-heading p {
  margin-top: 24px;
}
.rcti-editor-page .rcti-section-heading p,
.rcti-editor-page .rcti-delivery-card p,
.rcti-editor-page .rcti-form-hint {
  font-size: 13px;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}
.rcti-editor-page .rcti-editor-state {
  margin-top: 8px;
  gap: 12px;
}
.rcti-editor-page .rcti-editor-state-pill {
  padding: 4px 6px;
  line-height: 14px;
}
.rcti-editor-page .rcti-summary-card > strong {
  font: 700 20px/24px var(--font-family-mono, "JetBrains Mono", monospace);
}
.rcti-editor-page .rcti-summary-card > span {
  line-height: 18.2px;
}
.rcti-editor-page .rcti-editor-total-card {
  min-height: 154px;
  gap: 24px;
}
.rcti-editor-page .rcti-editor-total-card > strong {
  margin-top: 0;
}
.rcti-editor-page .rcti-breakdown-card dl {
  gap: 16px;
}
.rcti-editor-page .rcti-breakdown-card .rcti-aside-total-row {
  border-top: 1px solid var(--border-subtle, #dce3e2);
  padding-top: 12px;
  color: var(--text-primary, #142624);
  font-weight: 600;
}
.rcti-editor-page .rcti-breakdown-card p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 12px;
  line-height: 18px;
}
.rcti-editor-page .rcti-draft-total-heading {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  color: var(--text-primary, #142624);
  font-size: 16px;
  font-weight: 500;
}
.rcti-editor-page .rcti-draft-total-heading svg {
  color: var(--interactive-default, #0f766e);
}
.rcti-editor-page .rcti-field .MuiFormControl-root {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.rcti-editor-page .rcti-field .MuiInputLabel-root {
  position: static;
  max-width: none;
  transform: none;
  overflow: visible;
  color: var(--text-primary, #142624);
  font-size: 13px;
  line-height: 16.9px;
  letter-spacing: 0.065px;
}
.rcti-editor-page .rcti-field .MuiInputBase-root:not(.MuiInputBase-multiline) {
  min-height: 40px;
  border-radius: 10px;
}
.rcti-editor-page .rcti-field .MuiInputBase-input {
  box-sizing: border-box;
  padding-block: 9px;
  font-size: 13px;
  line-height: 20px;
}
.rcti-editor-page .rcti-field .MuiInputBase-input::placeholder {
  color: var(--text-tertiary, #6b7b78);
  opacity: 1;
}
.rcti-editor-page .rcti-field .MuiInputBase-root.Mui-disabled {
  background: var(--surface-secondary, #f4f7f7);
}
.rcti-editor-page
  .rcti-field
  .MuiInputBase-root.Mui-disabled
  .MuiInputBase-input {
  -webkit-text-fill-color: var(--text-secondary, #506360);
}
.rcti-editor-page .rcti-notes-field {
  margin-top: 0 !important;
}
.rcti-editor-page .rcti-pricing-basis {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: var(--text-primary, #142624);
  font-size: 13px;
  line-height: 16.9px;
}
.rcti-editor-page .rcti-pricing-basis .MuiFormControl-root {
  width: 144px;
}
.rcti-editor-page .rcti-pricing-basis .MuiInputBase-root {
  height: 40px;
  border-radius: 10px;
}
.rcti-editor-page .rcti-pricing-basis .MuiSelect-select {
  padding-block: 9px;
  font-size: 13px;
}
.rcti-editor-page .rcti-new-supplier-button {
  justify-content: flex-start;
  width: -moz-fit-content;
  width: fit-content;
  border-color: transparent;
  color: var(--interactive-default, #0f766e);
  background: transparent;
}
.rcti-editor-page .rcti-new-supplier-button:hover {
  background: var(--interactive-soft, #f0f8f7);
}
.rcti-editor-page
  .MuiOutlinedInput-root.Mui-focused
  .MuiOutlinedInput-notchedOutline {
  border-color: var(--focus-ring, #0f766e);
  border-width: 1px;
}
.rcti-editor-page .MuiInputLabel-root.Mui-focused {
  color: var(--interactive-default, #0f766e);
}
.rcti-editor-page .rcti-summary-card dl {
  gap: 14px;
}
.rcti-editor-page .rcti-summary-card dt,
.rcti-editor-page .rcti-summary-card dd {
  font-size: 13px;
  line-height: 18.2px;
}
.rcti-editor-page .rcti-header-actions {
  gap: 12px;
}
.rcti-editor-page .rcti-primary-button,
.rcti-editor-page .rcti-secondary-button {
  min-height: 40px;
  border-radius: 10px;
}
@media (max-width: 1100px) {
  .rcti-editor-page {
    padding: 20px 24px 40px;
  }
  .rcti-editor-page .rcti-page-heading {
    display: block;
    margin-bottom: 0;
  }
  .rcti-editor-page .rcti-editor-state {
    margin-top: 12px;
  }
  .rcti-editor-page .rcti-business-meta {
    margin-top: 16px;
  }
  .rcti-editor-page .rcti-mobile-editor-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 12px;
    margin: 24px 0 20px;
  }
  .rcti-editor-page .rcti-mobile-editor-actions > button {
    min-height: 44px;
  }
  .rcti-editor-page .rcti-mobile-editor-actions > button:last-child {
    grid-column: 1 / -1;
  }
  .rcti-editor-page .rcti-fields-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
  .rcti-editor-page .rcti-pricing-basis {
    align-items: stretch;
    flex-direction: column;
    gap: 6px;
  }
  .rcti-editor-page .rcti-pricing-basis .MuiFormControl-root,
  .rcti-editor-page .rcti-new-supplier-button {
    width: 100%;
  }
  .rcti-editor-page .rcti-new-supplier-button {
    justify-content: center;
  }
  .rcti-editor-page .rcti-field-wide {
    grid-column: auto;
  }
  .rcti-editor-layout {
    grid-template-columns: minmax(0, 1fr);
    gap: 24px;
  }
  .rcti-editor-aside {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-editor-page .rcti-editable-item-fields {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-editor-page .rcti-editable-item-fields > div:first-child,
  .rcti-editor-page .rcti-editable-item-fields > div:nth-child(2) {
    grid-column: auto;
  }
  .rcti-editor-page .rcti-item-actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
  .rcti-editor-page .rcti-item-actions > button,
  .rcti-editor-page .rcti-section-card > .MuiButton-root {
    width: 100%;
    min-height: 44px;
  }
  .rcti-editor-page .rcti-draft-total {
    min-height: 122px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    margin: 0 0 20px;
    border-radius: 14px;
    padding: 20px;
    box-shadow: 0 1px 2px rgb(14 26 32 / 6%);
  }
  .rcti-editor-page .rcti-draft-total strong {
    margin-left: 0;
    font-size: 20px;
    line-height: 24px;
  }
  .rcti-editor-page .rcti-draft-total small {
    font-size: 13px;
    line-height: 18.2px;
  }
  .rcti-editor-page .rcti-summary-card {
    padding: 16px;
  }
  .rcti-editor-page .rcti-editor-aside {
    gap: 24px;
  }
  .rcti-editor-page .rcti-editor-total-card {
    display: none;
  }
  .rcti-editor-page .rcti-draft-total {
    display: flex;
  }
  .rcti-editor-page .rcti-delivery-card > button {
    width: 100%;
    min-height: 44px;
  }
}
@media (max-width: 700px) {
  .rcti-editor-page {
    padding: 20px 16px 32px;
  }
  .rcti-editor-page .rcti-page-heading h1 {
    font-size: 24px;
    line-height: 30px;
  }
  .rcti-editor-page .rcti-editor-state {
    margin-top: 12px;
  }
  .rcti-editor-page .rcti-notice {
    padding: 16px;
  }
  .rcti-editor-page .rcti-section-card {
    padding: 16px;
    border-radius: 14px;
  }
  .rcti-editor-page .rcti-mobile-editor-actions {
    margin-top: 24px;
  }
  .rcti-editor-page .rcti-draft-total {
    min-height: 122px;
    padding: 16px;
  }
}
.rcti-editor-page .rcti-desktop-items {
  display: none !important;
}
.rcti-editor-page .rcti-item-column-headings,
.rcti-editor-page .rcti-editable-item-fields {
  display: grid;
  grid-template-columns: minmax(0, 284px) 64px 116px 100px 132px;
  gap: 8px;
}
.rcti-editor-page .rcti-item-column-headings {
  min-height: 44px;
  align-items: center;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 6px 6px 0 0;
  padding: 0 16px;
  color: var(--text-secondary, #506360);
  background: var(--surface-secondary, #f4f7f7);
  font-size: 11px;
  line-height: 14.3px;
  font-weight: 500;
}
.rcti-editor-page .rcti-item-column-headings span:last-child {
  text-align: right;
}
.rcti-editor-page .rcti-editable-items {
  display: grid;
  gap: 0;
}
.rcti-editor-page .rcti-editable-item {
  min-width: 0;
  border: 0;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 0;
  padding: 12px 0;
  background: transparent;
}
.rcti-editor-page .rcti-item-catalogue,
.rcti-editor-page .rcti-item-catalogue > div {
  min-width: 0;
}
.rcti-editor-page .rcti-item-catalogue {
  margin-bottom: 12px;
}
.rcti-editor-page .rcti-item-catalogue > div > span,
.rcti-editor-page .rcti-editable-item-fields > div > span {
  display: none;
}
.rcti-editor-page .rcti-item-catalogue .MuiInputBase-root {
  box-sizing: border-box;
  width: 100% !important;
  min-height: 40px;
  margin-top: 0 !important;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  padding-inline: 12px;
  background: var(--surface-primary, #fff);
}
.rcti-editor-page .rcti-editable-item-fields {
  align-items: start;
}
.rcti-editor-page .rcti-editable-item-fields > div {
  min-width: 0;
}
.rcti-editor-page .rcti-editable-item-fields .MuiGrid-container,
.rcti-editor-page .rcti-editable-item-fields .MuiGrid-item {
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
}
.rcti-editor-page .rcti-editable-item-fields .MuiInputBase-root {
  box-sizing: border-box;
  width: 100% !important;
  min-width: 0 !important;
  min-height: 40px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  padding-inline: 10px;
  color: var(--text-primary, #142624);
  background: var(--surface-primary, #fff);
}
.rcti-editor-page .rcti-editable-item-fields .MuiInput-root::before,
.rcti-editor-page .rcti-editable-item-fields .MuiInput-root::after {
  display: none;
}
.rcti-editor-page .rcti-editable-item-fields .MuiInputBase-input {
  box-sizing: border-box;
  min-width: 0 !important;
  padding: 9px 0;
  color: var(--text-primary, #142624);
  font-size: 13px;
  line-height: 20px;
}
.rcti-editor-page .rcti-editable-item-fields .MuiInputBase-input::placeholder {
  color: var(--text-tertiary, #6b7b78);
  opacity: 1;
}
.rcti-editor-page .rcti-editable-item-fields .MuiInputBase-root.Mui-disabled {
  background: var(--surface-secondary, #f4f7f7);
}
.rcti-editor-page .rcti-editable-item-fields > div:first-child {
  grid-column: 1;
}
.rcti-editor-page .rcti-discount-fields {
  display: flex;
  grid-column: 1 / -1;
  gap: 8px;
}
.rcti-editor-page .rcti-discount-fields > div {
  width: 148px;
  min-width: 0;
}
.rcti-editor-page .rcti-discount-fields > div > span {
  display: block;
  margin-bottom: 6px;
  color: var(--text-primary, #142624);
  font-size: 13px;
  line-height: 16.9px;
  font-weight: 500;
}
.rcti-editor-page .rcti-item-remove {
  grid-column: 1 / -1;
}
.rcti-editor-page .rcti-item-remove .MuiButton-root {
  width: 100%;
  min-height: 44px;
  border-radius: 10px;
}
.rcti-editor-page .rcti-upload-hint > span {
  display: grid;
  gap: 4px;
}
.rcti-editor-page .rcti-upload-hint strong {
  color: var(--text-primary, #142624);
  font-size: 13px;
  font-weight: 500;
}
.rcti-editor-page .rcti-upload-hint small {
  color: var(--text-secondary, #506360);
  font-size: 12px;
  line-height: 18px;
}
.rcti-editor-page .MuiOutlinedInput-notchedOutline {
  border: 1px solid var(--border-default, #cdd6d4) !important;
}
.rcti-editor-page
  .MuiOutlinedInput-root.Mui-focused
  .MuiOutlinedInput-notchedOutline {
  border-color: var(--focus-ring, #0f766e) !important;
  border-width: 2px !important;
}
.rcti-editor-page .MuiInputLabel-root:not(.Mui-focused) {
  color: var(--text-primary, #142624) !important;
}
.rcti-editor-page .MuiInput-root::before {
  border-bottom: 1px solid var(--border-default, #cdd6d4) !important;
}
.rcti-editor-page
  .MuiInput-root:hover:not(.Mui-disabled, .Mui-focused)::before {
  border-bottom: 1px solid var(--border-strong, #8b9996) !important;
}
.rcti-editor-page .MuiInput-root.Mui-focused::after {
  border-bottom: 2px solid var(--focus-ring, #0f766e) !important;
}
.rcti-editor-page .rcti-item-column-headings,
.rcti-editor-page .rcti-editable-item-fields {
  grid-template-columns:
    minmax(0, 2.8fr)
    minmax(48px, 0.62fr)
    minmax(82px, 1.05fr)
    minmax(66px, 0.84fr)
    minmax(94px, 1.15fr);
}
.rcti-editor-page .rcti-item-catalogue .MuiAutocomplete-root,
.rcti-editor-page .rcti-item-catalogue .MuiFormControl-root,
.rcti-editor-page
  .rcti-editable-item-fields
  > div:not(.rcti-discount-fields):not(.rcti-item-remove)
  .MuiFormControl-root,
.rcti-editor-page
  .rcti-editable-item-fields
  > div:not(.rcti-discount-fields):not(.rcti-item-remove)
  .MuiGrid-container,
.rcti-editor-page
  .rcti-editable-item-fields
  > div:not(.rcti-discount-fields):not(.rcti-item-remove)
  .MuiGrid-item,
.rcti-editor-page
  .rcti-editable-item-fields
  > div:not(.rcti-discount-fields):not(.rcti-item-remove)
  .MuiTextField-root {
  box-sizing: border-box;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  margin-inline: 0 !important;
}
.rcti-editor-page .rcti-item-catalogue .MuiInputBase-root,
.rcti-editor-page
  .rcti-editable-item-fields
  > div:not(.rcti-discount-fields):not(.rcti-item-remove)
  .MuiInputBase-root {
  box-sizing: border-box;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}
.rcti-editor-page
  .rcti-editable-item-fields
  > div:not(.rcti-discount-fields):not(.rcti-item-remove)
  .MuiInputBase-input {
  box-sizing: border-box;
  width: 100%;
  min-width: 0 !important;
}
@media (max-width: 1100px) {
  .rcti-editor-page .rcti-item-column-headings {
    display: none;
  }
  .rcti-editor-page
    .rcti-editable-item-fields
    > div:first-child
    .MuiInputBase-root {
    min-height: 120px;
    align-items: flex-start;
  }
  .rcti-editor-page .rcti-item-catalogue > div > span,
  .rcti-editor-page .rcti-editable-item-fields > div > span {
    display: block;
  }
  .rcti-editor-page .rcti-item-catalogue > div > span,
  .rcti-editor-page .rcti-editable-item-fields > div > span {
    margin-bottom: 6px;
    color: var(--text-primary, #142624);
    font-size: 13px;
    line-height: 16.9px;
    font-weight: 500;
  }
  .rcti-editor-page .rcti-editable-item-fields > div:first-child {
    grid-column: auto;
  }
  .rcti-editor-page .rcti-discount-fields {
    display: contents;
  }
  .rcti-editor-page .rcti-discount-fields > div {
    width: auto;
    min-width: 0;
  }
  .rcti-editor-page .rcti-item-remove {
    grid-column: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/rctiFlow.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,uDAAuD;EACvD,4CAA4C;EAC5C,qDAAqD;EACrD,yCAAyC;EACzC,4CAA4C;EAC5C,kDAAkD;EAClD,sCAAsC;EACtC,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;AACV;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,qDAAqD;EACrD,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,qDAAqD;AACvD;AACA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;AACA;;;EAGE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,SAAS;EACT,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;IAChB,gDAAgD;EAClD;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;;IAEE,iBAAiB;EACnB;EACA;;IAEE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,QAAQ;IACR,wBAAwB;IACxB,wCAAwC;IACxC,kBAAkB;IAClB,+BAA+B;EACjC;EACA;IACE,SAAO;IACP,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF;AACA,uBAAuB;AACvB;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,uEAAuE;AACzE;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,uEAAuE;AACzE;AACA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,qCAAqC;AACvC;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,uEAAuE;AACzE;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,uEAAuE;EACvE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;AACA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;AACA;;EAEE,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wCAAwC;EACxC,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;;EAEE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iEAAiE;AACnE;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,oCAAoC;IACpC,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;EACjC;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,SAAO;IACP,QAAQ;EACV;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,gDAAgD;IAChD,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb;;UAEM;IACN,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,eAAe;IACf,wBAAwB;IACxB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb;;UAEM;IACN,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,2CAA2C;IAC3C,iBAAiB;IACjB,+BAA+B;EACjC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,oBAAoB;IACpB,oBAAoB;IACpB,SAAS;EACX;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,eAAe;EACjB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;IACX,WAAW;EACb;EACA;IACE,cAAc;IACd,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,eAAe;EACjB;EACA;IACE,qCAAqC;IACrC,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,cAAc;IACd,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oBAAoB;EACtB;EACA;;IAEE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAO;IACP,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA,mCAAmC;AACnC;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,8CAA8C;EAC9C,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,iDAAiD;AACnD;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,wCAAwC;EACxC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,uEAAuE;EACvE,iBAAiB;AACnB;AACA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,+BAA+B;EAC/B,0CAA0C;AAC5C;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,qCAAqC;AACvC;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;IAChB,gDAAgD;EAClD;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,uEAAuE;EACzE;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,+BAA+B;EACjC;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;IAC3C,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;;IAEE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,SAAS;EACX;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;AACF;AACA,sDAAsD;AACtD;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,kCAAkC;EAClC,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;AACA;;EAEE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,4CAA4C;EAC5C,4CAA4C;EAC5C,4EAA4E;AAC9E;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;;IAEE,cAAc;IACd,WAAW;EACb;AACF;;AAEA,8EAA8E;AAC9E;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;;EAEE,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;AACA;;EAEE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,mDAAmD;EACnD,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,6CAA6C;AAC/C;AACA;;;;EAIE,uDAAuD;AACzD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,uBAAkB;EAAlB,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;EAC1C,uBAAuB;AACzB;AACA;EACE,4CAA4C;AAC9C;AACA;;;EAGE,wCAAwC;EACxC,iBAAiB;AACnB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,SAAS;AACX;AACA;;EAEE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gDAAgD;IAChD,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;EACV;EACA;;IAEE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;EACA;;IAEE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;EAC1C;EACA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,aAAa;EACb,8DAA8D;EAC9D,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sDAAsD;EACtD,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;EACrC,6CAA6C;EAC7C,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,MAAM;AACR;AACA;EACE,YAAY;EACZ,SAAS;EACT,sDAAsD;EACtD,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;AACA;;EAEE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,gDAAgD;EAChD,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,gDAAgD;EAChD,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;EACnC,wCAAwC;AAC1C;AACA;;EAEE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,UAAU;AACZ;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,2DAA2D;AAC7D;AACA;;;EAGE,mDAAmD;EACnD,4BAA4B;AAC9B;AACA;EACE,8CAA8C;AAChD;AACA;EACE,kEAAkE;AACpE;AACA;;EAEE,iEAAiE;AACnE;AACA;EACE,8DAA8D;AAChE;AACA;;EAEE;;;;;wBAKsB;AACxB;AACA;;;;;;;;;;;;;;;;;;EAkBE,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;;;;;EAKE,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;;;;EAIE,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE;IACE,aAAa;EACf;EACA;;;;IAIE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;;IAEE,cAAc;EAChB;EACA;;IAEE,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".rcti-flow-shell {\n  --rcti-bg: var(--bg-primary, #f4f7f7);\n  --rcti-surface: var(--surface-primary, #fff);\n  --rcti-surface-muted: var(--surface-secondary, #f4f7f7);\n  --rcti-border: var(--border-subtle, #dce3e2);\n  --rcti-border-default: var(--border-default, #cdd6d4);\n  --rcti-text: var(--text-primary, #142624);\n  --rcti-muted: var(--text-secondary, #506360);\n  --rcti-accent: var(--interactive-default, #0f766e);\n  --rcti-info: var(--info-soft, #eff6ff);\n  min-height: 100vh;\n  color: var(--rcti-text);\n  background: var(--rcti-bg);\n  font-family: inherit;\n}\n.rcti-flow-main {\n  min-width: 0;\n  min-height: 100vh;\n}\n.rcti-editor-page {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 28px 32px 48px;\n}\n.rcti-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 18px;\n  border: 0;\n  padding: 0;\n  color: var(--rcti-accent);\n  background: transparent;\n  font: inherit;\n  cursor: pointer;\n}\n.rcti-page-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 22px;\n}\n.rcti-page-heading h1 {\n  margin: 0;\n  color: var(--rcti-text);\n  font-size: 30px;\n  line-height: 1.2;\n  font-weight: 650;\n}\n.rcti-eyebrow {\n  margin: 0 0 5px;\n  color: var(--rcti-muted);\n  font-size: 13px;\n}\n.rcti-subtitle,\n.rcti-business-meta {\n  margin: 7px 0 0;\n  color: var(--rcti-muted);\n  font-size: 14px;\n}\n.rcti-header-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 9px;\n}\n.rcti-flow-shell .rcti-primary-button,\n.rcti-flow-shell .rcti-secondary-button {\n  height: 40px;\n  min-height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 1px solid var(--rcti-border-default);\n  border-radius: 10px;\n  padding: 0 12px;\n  color: var(--rcti-text);\n  background: var(--rcti-surface);\n  text-transform: none;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: normal;\n  letter-spacing: 0;\n  box-shadow: none;\n}\n.rcti-flow-shell .rcti-primary-button {\n  border-color: var(--rcti-accent);\n  color: var(--on-interactive-primary, #fff) !important;\n  background: var(--rcti-accent);\n  cursor: pointer;\n}\n.rcti-flow-shell .rcti-primary-button:hover {\n  border-color: var(--interactive-pressed, #0a4a46);\n  background: var(--interactive-pressed, #0a4a46);\n  color: var(--on-interactive-primary, #fff) !important;\n  box-shadow: none;\n}\n.rcti-flow-shell .rcti-primary-button:active {\n  border-color: var(--interactive-pressed, #0a4a46);\n  background: var(--interactive-pressed, #0a4a46);\n  color: var(--on-interactive-primary, #fff) !important;\n}\n.rcti-flow-shell .rcti-primary-button:focus-visible {\n  outline: 2px solid var(--focus-ring, #41a89e);\n  outline-offset: 2px;\n}\n.rcti-flow-shell .rcti-primary-button.Mui-disabled {\n  color: var(--text-disabled);\n  background: var(--interactive-disabled);\n}\n.rcti-flow-shell\n  :is(.rcti-primary-button, .rcti-secondary-button)\n  > svg {\n  width: 16px;\n  height: 16px;\n}\n.rcti-flow-shell .rcti-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 22px;\n  border: 1px solid var(--info-border, #c9dcf7);\n  border-radius: 10px;\n  padding: 14px 16px;\n  color: var(--rcti-text);\n  background: var(--rcti-info);\n}\n.rcti-notice > svg {\n  flex: 0 0 auto;\n  margin-top: 2px;\n  color: var(--rcti-accent);\n}\n.rcti-notice div {\n  display: grid;\n  gap: 4px;\n}\n.rcti-notice span {\n  color: var(--rcti-muted);\n  font-size: 13px;\n}\n.rcti-editor-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  align-items: start;\n  gap: 20px;\n}\n.rcti-editor-main-column {\n  display: grid;\n  min-width: 0;\n  gap: 16px;\n}\n.rcti-section-card,\n.rcti-summary-card {\n  min-width: 0;\n  border: 1px solid var(--rcti-border);\n  border-radius: 12px;\n  padding: 22px;\n  color: var(--rcti-text);\n  background: var(--rcti-surface);\n}\n.rcti-section-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n.rcti-section-heading h2,\n.rcti-summary-card h2 {\n  margin: 0;\n  color: var(--rcti-text);\n  font-size: 17px;\n  line-height: 1.35;\n  font-weight: 650;\n}\n.rcti-section-heading p,\n.rcti-delivery-card p {\n  margin: 5px 0 0;\n  color: var(--rcti-muted);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.rcti-section-tag {\n  border-radius: 20px;\n  padding: 5px 9px;\n  color: var(--rcti-muted);\n  background: var(--rcti-surface-muted);\n  font-size: 12px;\n  white-space: nowrap;\n}\n.rcti-fields-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n.rcti-field {\n  min-width: 0;\n}\n.rcti-field-wide {\n  grid-column: 1 / -1;\n}\n.rcti-field .MuiFormControl-root,\n.rcti-field .MuiTextField-root {\n  width: 100%;\n}\n.rcti-flow-shell .MuiInputBase-root {\n  color: var(--rcti-text);\n  background: var(--rcti-surface);\n}\n.rcti-flow-shell .MuiOutlinedInput-notchedOutline {\n  border-color: var(--rcti-border-default);\n}\n.rcti-flow-shell .MuiInputLabel-root {\n  color: var(--rcti-muted);\n}\n.rcti-field-error {\n  margin: 5px 0 0;\n  color: var(--danger-text, #a3301f);\n  font-size: 12px;\n}\n.rcti-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--rcti-border);\n  border-radius: 8px;\n}\n.rcti-table-wrap > div {\n  min-width: 690px;\n}\n.rcti-totals-grid {\n  margin-top: 18px;\n}\n.rcti-total-field {\n  grid-column: span 2;\n}\n.rcti-upload-hint {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px dashed var(--rcti-border-default);\n  border-radius: 8px;\n  padding: 16px;\n  color: var(--rcti-muted);\n  font-size: 13px;\n}\n.rcti-upload-hint svg {\n  color: var(--rcti-accent);\n}\n.rcti-editor-aside {\n  position: sticky;\n  top: 82px;\n  display: grid;\n  gap: 14px;\n}\n.rcti-summary-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.rcti-summary-title svg {\n  color: var(--rcti-accent);\n}\n.rcti-summary-card > strong {\n  display: block;\n  margin-top: 20px;\n  color: var(--rcti-text);\n  font-size: 27px;\n  font-weight: 650;\n}\n.rcti-summary-card > span {\n  display: block;\n  margin-top: 3px;\n  color: var(--rcti-muted);\n  font-size: 13px;\n}\n.rcti-summary-card hr {\n  height: 1px;\n  margin: 18px 0;\n  border: 0;\n  background: var(--rcti-border);\n}\n.rcti-summary-card dl {\n  display: grid;\n  gap: 13px;\n  margin: 0;\n}\n.rcti-summary-card dl div {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 13px;\n}\n.rcti-summary-card dt {\n  color: var(--rcti-muted);\n}\n.rcti-summary-card dd {\n  max-width: 58%;\n  margin: 0;\n  color: var(--rcti-text);\n  text-align: right;\n  overflow-wrap: anywhere;\n}\n.rcti-delivery-card p {\n  margin-top: 10px;\n}\n.rcti-mobile-actions {\n  display: none;\n}\n@media (max-width: 1100px) {\n  .rcti-editor-page {\n    padding: 22px 20px 40px;\n  }\n  .rcti-editor-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-editor-aside {\n    position: static;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .rcti-summary-card > strong {\n    font-size: 23px;\n  }\n}\n@media (max-width: 700px) {\n  .rcti-editor-page {\n    padding: 18px 14px 30px;\n  }\n  .rcti-page-heading {\n    display: block;\n  }\n  .rcti-page-heading h1 {\n    font-size: 25px;\n  }\n  .rcti-header-actions {\n    display: none;\n  }\n  .rcti-fields-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 14px;\n  }\n  .rcti-field-wide,\n  .rcti-total-field {\n    grid-column: auto;\n  }\n  .rcti-section-card,\n  .rcti-summary-card {\n    padding: 16px;\n    border-radius: 10px;\n  }\n  .rcti-section-heading {\n    margin-bottom: 14px;\n  }\n  .rcti-section-heading h2,\n  .rcti-summary-card h2 {\n    font-size: 16px;\n  }\n  .rcti-editor-aside {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-mobile-actions {\n    position: sticky;\n    bottom: 0;\n    z-index: 3;\n    display: flex;\n    gap: 8px;\n    margin: 18px -14px -30px;\n    border-top: 1px solid var(--rcti-border);\n    padding: 10px 14px;\n    background: var(--rcti-surface);\n  }\n  .rcti-mobile-actions > button {\n    flex: 1;\n    min-width: 0;\n    padding: 8px;\n    font-size: 12px;\n  }\n}\n/* RCTI register page */\n.rcti-list-page {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.rcti-mobile-organisation {\n  display: none;\n}\n.rcti-list-heading {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: start;\n  gap: 12px 20px;\n}\n.rcti-list-heading h1 {\n  margin: 0;\n  color: var(--rcti-text);\n  font-size: 30px;\n  line-height: 1.2;\n  font-weight: 650;\n}\n.rcti-list-heading > div:first-child > p {\n  margin: 7px 0 0;\n  color: var(--rcti-muted);\n  font-size: 14px;\n}\n.rcti-list-heading > .rcti-primary-button {\n  grid-column: 2;\n  grid-row: 1;\n}\n.rcti-list-context {\n  grid-column: 1 / -1;\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 8px;\n  color: var(--rcti-muted);\n  font-size: 13px;\n}\n.rcti-financial-summary {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px 24px;\n  margin-top: 0;\n}\n.rcti-financial-card {\n  min-width: 0;\n  min-height: 154px;\n  border: 1px solid var(--rcti-border);\n  border-radius: 14px;\n  padding: 24px;\n  background: var(--rcti-surface);\n}\n.rcti-financial-card > div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n.rcti-financial-card h2 {\n  margin: 0;\n  color: var(--rcti-text);\n  font-size: 17px;\n  font-weight: 600;\n}\n.rcti-financial-card svg {\n  width: 20px;\n  height: 20px;\n  color: var(--rcti-accent);\n}\n.rcti-financial-card > strong {\n  display: block;\n  margin-top: 24px;\n  color: var(--rcti-text);\n  font: 700 23px/1.2 var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.rcti-financial-card > p {\n  margin: 8px 0 0;\n  color: var(--rcti-muted);\n  font-size: 13px;\n}\n.rcti-summary-note {\n  grid-column: 1 / -1;\n  margin: 0;\n  color: var(--rcti-muted);\n  font-size: 13px;\n}\n.rcti-filters {\n  margin-top: 0;\n}\n.rcti-status-tabs {\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n  border-bottom: 1px solid var(--rcti-border);\n  scrollbar-width: thin;\n}\n.rcti-status-tabs button {\n  flex: 0 0 auto;\n  min-height: 42px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  padding: 10px 16px;\n  color: var(--rcti-muted);\n  background: transparent;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.15s ease;\n}\n.rcti-status-tabs button:hover {\n  color: var(--text-secondary, #506360);\n  background: transparent;\n  box-shadow: none;\n}\n.rcti-status-tabs button.is-active {\n  border-bottom-color: var(--rcti-accent);\n  color: var(--rcti-accent);\n}\n.rcti-list-filter-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n}\n.rcti-list-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: min(420px, 40%);\n  height: 40px;\n  border: 1px solid var(--rcti-border-default);\n  border-radius: 10px;\n  padding: 0 12px;\n  color: var(--rcti-muted);\n  background: var(--rcti-surface);\n}\n.rcti-list-search > svg {\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n}\n.rcti-list-search:focus-within {\n  border: 2px solid var(--interactive-default, #0f766e);\n  padding-inline: 11px;\n  box-shadow: var(--field-focus-ring, 0 0 0 3px rgba(15, 186, 196, 0.22));\n}\n.rcti-list-search input {\n  min-width: 0;\n  width: 100%;\n  border: 0;\n  outline: 0;\n  color: var(--rcti-text);\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n}\n.rcti-list-search input::placeholder {\n  color: var(--text-disabled);\n  opacity: 1;\n}\n.rcti-list-search button {\n  display: none;\n  border: 0;\n  color: var(--rcti-accent);\n  background: transparent;\n}\n.rcti-filter-select {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  border: 1px solid var(--rcti-border-default);\n  border-radius: 10px;\n  padding: 0 12px;\n  background: var(--rcti-surface);\n}\n.rcti-filter-select select {\n  width: 100%;\n  min-width: 100px;\n  appearance: none;\n  border: 0;\n  outline: 0;\n  padding-right: 22px;\n  color: var(--rcti-text);\n  background: transparent;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.rcti-filter-select > svg {\n  position: absolute;\n  right: 10px;\n  width: 16px;\n  height: 16px;\n  color: var(--rcti-muted);\n  pointer-events: none;\n}\n.rcti-due-select select {\n  min-width: 144px;\n}\n.rcti-flow-shell .rcti-refresh-button {\n  display: none;\n  min-width: 40px;\n  height: 40px;\n  border: 1px solid var(--rcti-border-default);\n  border-radius: 10px;\n  color: var(--rcti-muted);\n  background: var(--rcti-surface);\n}\n.rcti-date-hint {\n  margin: 10px 0 0;\n  color: var(--rcti-muted);\n  font-size: 13px;\n}\n.rcti-register-card {\n  margin-top: 0;\n  overflow: hidden;\n  border: 1px solid var(--rcti-border);\n  border-radius: 14px;\n  background: var(--rcti-surface);\n  box-shadow: 0 1px 2px rgb(14 26 32 / 6%);\n}\n.rcti-register-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 50px;\n  gap: 12px;\n  padding: 0;\n  color: var(--rcti-text);\n  font-size: 13px;\n}\n.rcti-register-heading span {\n  color: var(--rcti-muted);\n  font-weight: 400;\n}\n.rcti-register-table .rdt_Table {\n  color: var(--rcti-text);\n  background: var(--rcti-surface);\n}\n.rcti-register-table .rdt_TableHeadRow {\n  background: var(--rcti-surface-muted);\n}\n.rcti-register-table .rdt_TableCol,\n.rcti-register-table .rdt_TableCell {\n  overflow: visible;\n}\n.rcti-register-table .rdt_TableCol_Sortable {\n  color: var(--rcti-muted);\n}\n.rcti-register-table .rdt_TableRow {\n  border-bottom-color: var(--rcti-border) !important;\n}\n.rcti-register-table .rdt_TableRow:hover {\n  background: var(--rcti-surface-muted) !important;\n}\n.rcti-register-number {\n  color: var(--rcti-accent);\n  text-decoration: none;\n  font: 500 14px/1.4 var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.rcti-register-number:hover {\n  text-decoration: underline;\n}\n.rcti-register-supplier {\n  color: var(--rcti-text);\n}\n.rcti-register-money {\n  color: var(--rcti-text);\n  font: 500 16px/1.4 var(--font-family-mono, \"JetBrains Mono\", monospace);\n  white-space: nowrap;\n}\n.rcti-status-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n.rcti-status-pill {\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  border-radius: 12px;\n  padding: 2px 8px;\n  font-size: 11px;\n  line-height: 16px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n.rcti-status-overdue-payable {\n  color: var(--danger-text, #a3301f);\n  background: var(--danger-soft, #fef2f1);\n}\n.rcti-status-payment-due {\n  color: var(--warning-text, #7d4412);\n  background: var(--warning-soft, #fef8ec);\n}\n.rcti-status-draft,\n.rcti-status-voided {\n  color: var(--text-secondary);\n  background: var(--surface-tertiary);\n}\n.rcti-status-paid {\n  color: var(--success-text, #115a33);\n  background: var(--success-soft, #edfbf2);\n}\n.rcti-status-meta {\n  max-width: 150px;\n  color: var(--rcti-muted);\n  font-size: 12px;\n  line-height: 16px;\n  white-space: normal;\n}\n.rcti-mobile-register,\n.rcti-tablet-columns {\n  display: none;\n}\n.rcti-list-empty {\n  display: flex;\n  min-height: 260px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  color: var(--rcti-muted);\n  text-align: center;\n}\n.rcti-list-empty svg {\n  width: 24px;\n  height: 24px;\n  margin-bottom: 4px;\n  color: var(--rcti-accent);\n}\n.rcti-list-empty strong {\n  color: var(--rcti-text);\n  font-size: 15px;\n}\n.rcti-list-empty span {\n  font-size: 13px;\n}\n.rcti-list-empty button {\n  display: inline-flex;\n  height: 40px;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 6px;\n  padding: 0 12px;\n  border: 1px solid var(--rcti-accent);\n  border-radius: 10px;\n  background: var(--rcti-surface);\n  color: var(--rcti-accent);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: normal;\n  letter-spacing: 0;\n  cursor: pointer;\n}\n.rcti-list-empty button:hover {\n  border-color: var(--interactive-pressed, #0a4a46);\n  background: var(--interactive-pressed, #0a4a46);\n  color: var(--on-interactive-primary, #fff);\n}\n.rcti-list-empty button > svg {\n  width: 16px;\n  height: 16px;\n}\n.rcti-list-empty button:focus-visible {\n  outline: 2px solid var(--focus-ring, #41a89e);\n  outline-offset: 2px;\n}\n.rcti-register-footer {\n  display: flex;\n  min-height: 50px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border-top: 1px solid var(--rcti-border);\n  padding: 0 16px;\n  color: var(--rcti-muted);\n  font-size: 12px;\n}\n.rcti-register-footer > div {\n  display: flex;\n  gap: 8px;\n}\n.rcti-register-footer button {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--rcti-border);\n  border-radius: 8px;\n  color: var(--rcti-muted);\n  background: var(--rcti-surface);\n  font-size: 20px;\n  cursor: pointer;\n}\n.rcti-register-footer button:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n.rcti-mobile-card-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n.rcti-mobile-card-top .MuiCheckbox-root {\n  margin-left: -8px;\n  padding: 4px;\n  color: var(--border-strong);\n}\n.rcti-mobile-supplier {\n  min-width: 0;\n  overflow: hidden;\n  color: var(--rcti-text);\n  font-size: 14px;\n  font-weight: 500;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rcti-mobile-actions-menu {\n  margin-left: auto;\n}\n.rcti-mobile-document {\n  color: var(--rcti-muted);\n  font-size: 12px;\n}\n.rcti-mobile-financials {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 14px;\n}\n.rcti-mobile-financials > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 4px;\n}\n.rcti-mobile-financials small {\n  color: var(--rcti-muted);\n  font-size: 11px;\n}\n.rcti-mobile-financials span,\n.rcti-mobile-financials strong {\n  color: var(--rcti-text);\n  font-size: 12px;\n  font-weight: 500;\n  overflow-wrap: anywhere;\n}\n.rcti-mobile-financials strong {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.rcti-mobile-delivery {\n  margin: 8px 0 0;\n  color: var(--rcti-muted);\n  font-size: 11px;\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n}\n@media (max-width: 1100px) {\n  .rcti-list-page {\n    padding: 20px 24px 36px;\n  }\n  .rcti-mobile-organisation {\n    display: flex;\n    min-height: 54px;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 18px;\n    border: 1px solid var(--rcti-border);\n    border-radius: 10px;\n    padding: 8px 12px;\n    background: var(--rcti-surface);\n  }\n  .rcti-mobile-organisation {\n    max-width: 240px;\n    margin-left: auto;\n  }\n  .rcti-organisation-avatar {\n    display: grid;\n    width: 32px;\n    height: 32px;\n    place-items: center;\n    border: 1px solid var(--rcti-border);\n    border-radius: 50%;\n    color: var(--rcti-accent);\n    font-size: 10px;\n    font-weight: 600;\n  }\n  .rcti-mobile-organisation > span:nth-child(2) {\n    display: grid;\n    flex: 1;\n    gap: 2px;\n  }\n  .rcti-mobile-organisation strong {\n    color: var(--rcti-text);\n    font-size: 13px;\n    font-weight: 500;\n  }\n  .rcti-mobile-organisation small {\n    color: var(--rcti-muted);\n    font-size: 11px;\n  }\n  .rcti-mobile-organisation > svg {\n    width: 16px;\n    height: 16px;\n    color: var(--rcti-accent);\n  }\n  .rcti-financial-summary {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n    margin-top: 20px;\n  }\n  .rcti-financial-card:nth-child(3) {\n    grid-column: 1 / -1;\n  }\n  .rcti-financial-card {\n    min-height: 122px;\n    padding: 16px;\n  }\n  .rcti-financial-card > strong {\n    margin-top: 14px;\n    font-size: 19px;\n  }\n  .rcti-financial-card h2 {\n    font-size: 14px;\n  }\n  .rcti-financial-card > p {\n    margin-top: 6px;\n    font-size: 11px;\n  }\n  .rcti-filters {\n    margin-top: 12px;\n  }\n  .rcti-list-filter-row {\n    flex-wrap: wrap;\n  }\n  .rcti-list-search {\n    flex: 1 1 100%;\n    width: 100%;\n  }\n  .rcti-filter-select {\n    flex: 0 1 auto;\n  }\n  .rcti-register-table {\n    display: none;\n  }\n  .rcti-mobile-register {\n    display: block;\n  }\n  .rcti-tablet-columns {\n    display: grid;\n    grid-template-columns:\n      28px minmax(0, 1.2fr) minmax(120px, 0.9fr) minmax(130px, 1fr)\n      40px;\n    align-items: center;\n    min-height: 40px;\n    border-block: 1px solid var(--rcti-border);\n    padding: 0 12px;\n    color: var(--rcti-muted);\n    background: var(--rcti-surface-muted);\n    font-size: 11px;\n    font-weight: 500;\n  }\n  .rcti-register-mobile-card {\n    display: grid;\n    grid-template-columns:\n      28px minmax(0, 1.2fr) minmax(120px, 0.9fr) minmax(130px, 1fr)\n      40px;\n    align-items: center;\n    min-height: 84px;\n    gap: 3px 0;\n    border-bottom: 1px solid var(--rcti-border);\n    padding: 8px 12px;\n    background: var(--rcti-surface);\n  }\n  .rcti-mobile-card-top {\n    display: contents;\n  }\n  .rcti-mobile-card-top .MuiCheckbox-root {\n    grid-column: 1;\n    grid-row: 1 / span 3;\n    margin-left: -6px;\n  }\n  .rcti-mobile-supplier {\n    grid-column: 2;\n    grid-row: 1;\n    font-size: 12px;\n  }\n  .rcti-mobile-card-top > .rcti-status-pill {\n    grid-column: 3;\n    grid-row: 1;\n    justify-self: start;\n  }\n  .rcti-mobile-actions-menu {\n    grid-column: 5;\n    grid-row: 1 / span 2;\n    justify-self: center;\n    margin: 0;\n  }\n  .rcti-register-mobile-card > .rcti-register-number {\n    grid-column: 2;\n    grid-row: 2;\n    font-size: 12px;\n  }\n  .rcti-mobile-document {\n    grid-column: 2;\n    grid-row: 3;\n    font-size: 10px;\n  }\n  .rcti-mobile-financials {\n    display: contents;\n  }\n  .rcti-mobile-financials > div:first-child {\n    grid-column: 3;\n    grid-row: 2 / span 2;\n  }\n  .rcti-mobile-financials > div:nth-child(2) {\n    grid-column: 4;\n    grid-row: 1 / span 2;\n  }\n  .rcti-mobile-financials > div:nth-child(3) {\n    grid-column: 4;\n    grid-row: 3;\n  }\n  .rcti-mobile-financials small {\n    font-size: 10px;\n  }\n  .rcti-mobile-financials span,\n  .rcti-mobile-financials strong {\n    font-size: 11px;\n  }\n  .rcti-mobile-delivery {\n    grid-column: 3;\n    grid-row: 4;\n    font-size: 10px;\n  }\n  .rcti-status-meta {\n    display: none;\n  }\n  .rcti-register-footer {\n    min-height: 48px;\n  }\n  .rcti-date-hint {\n    margin-top: 8px;\n    font-size: 11px;\n  }\n}\n@media (max-width: 600px) {\n  .rcti-list-page {\n    padding: 16px 16px 28px;\n  }\n  .rcti-mobile-organisation {\n    max-width: none;\n    margin: 0 0 16px;\n  }\n  .rcti-list-heading {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  .rcti-list-heading h1 {\n    font-size: 24px;\n  }\n  .rcti-list-heading > .rcti-primary-button {\n    grid-column: 1;\n    grid-row: 2;\n    width: 100%;\n  }\n  .rcti-list-context {\n    grid-column: 1;\n    flex-direction: column;\n    gap: 4px;\n    margin-top: 4px;\n    font-size: 12px;\n  }\n  .rcti-financial-summary {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 10px;\n    margin-top: 18px;\n  }\n  .rcti-financial-card:nth-child(3) {\n    grid-column: auto;\n  }\n  .rcti-financial-card {\n    min-height: 122px;\n    padding: 16px;\n  }\n  .rcti-financial-card > strong {\n    margin-top: 14px;\n  }\n  .rcti-summary-note {\n    font-size: 11px;\n    line-height: 1.5;\n  }\n  .rcti-status-tabs button {\n    min-height: 40px;\n    padding: 9px 11px;\n    font-size: 11px;\n  }\n  .rcti-list-filter-row {\n    gap: 8px;\n  }\n  .rcti-list-search {\n    height: 40px;\n  }\n  .rcti-list-search button {\n    display: block;\n    flex: 0 0 auto;\n    padding: 2px;\n  }\n  .rcti-list-search button svg {\n    width: 16px;\n    height: 16px;\n  }\n  .rcti-filter-select {\n    flex: 1 1 calc(50% - 4px);\n    min-width: 0;\n    height: 38px;\n    padding-inline: 10px;\n  }\n  .rcti-filter-select select,\n  .rcti-due-select select {\n    min-width: 0;\n    width: 100%;\n    font-size: 11px;\n  }\n  .rcti-flow-shell .rcti-refresh-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 38px;\n    width: 38px;\n    height: 38px;\n    padding: 0;\n  }\n  .rcti-date-hint {\n    font-size: 10px;\n  }\n  .rcti-table-card {\n    margin-top: 16px;\n    border-radius: 10px;\n  }\n  .rcti-table-card .quotation-table-context {\n    height: 44px;\n    padding-inline: 12px;\n  }\n  .rcti-table-card .quotation-table-context strong {\n    font-size: 12px;\n  }\n  .rcti-table-card .quotation-table-context span {\n    display: none;\n  }\n  .rcti-tablet-columns {\n    display: none;\n  }\n  .rcti-register-mobile-card {\n    display: block;\n    min-height: 0;\n    padding: 14px 12px;\n  }\n  .rcti-mobile-card-top {\n    display: flex;\n    gap: 7px;\n  }\n  .rcti-mobile-card-top .MuiCheckbox-root {\n    margin-left: -6px;\n  }\n  .rcti-mobile-supplier {\n    flex: 1;\n    font-size: 13px;\n  }\n  .rcti-mobile-card-top > .rcti-status-pill {\n    align-self: center;\n  }\n  .rcti-mobile-actions-menu {\n    margin-left: 0;\n  }\n  .rcti-register-mobile-card > .rcti-register-number {\n    display: inline-block;\n    margin: 7px 0 5px 32px;\n    font-size: 12px;\n  }\n  .rcti-mobile-document {\n    margin-left: 32px;\n    font-size: 11px;\n  }\n  .rcti-mobile-financials {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n    margin: 12px 0 0 32px;\n  }\n  .rcti-mobile-financials > div:first-child {\n    grid-column: 1 / -1;\n  }\n  .rcti-mobile-financials > div:nth-child(2),\n  .rcti-mobile-financials > div:nth-child(3) {\n    grid-column: auto;\n  }\n  .rcti-mobile-financials small {\n    font-size: 10px;\n  }\n  .rcti-mobile-financials span,\n  .rcti-mobile-financials strong {\n    font-size: 12px;\n  }\n  .rcti-mobile-delivery {\n    margin: 8px 0 0 32px;\n  }\n  .rcti-table-card .quotation-pagination {\n    height: 44px;\n    padding-inline: 12px;\n  }\n  .rcti-table-card .quotation-pagination span {\n    font-size: 10px;\n  }\n  .rcti-table-card .quotation-pagination-btns {\n    gap: 6px;\n  }\n  .rcti-table-card .quotation-pagination-btns button {\n    width: 30px;\n    height: 30px;\n  }\n}\n/* RCTI editor responsive details */\n.rcti-flow-shell {\n  --dn-surface: var(--rcti-surface);\n  --dn-border: var(--rcti-border);\n  --dn-border-strong: var(--rcti-border-default);\n  --dn-text: var(--rcti-text);\n  --dn-muted: var(--rcti-muted);\n  --dn-brand: var(--rcti-accent);\n  --dn-brand-soft: var(--interactive-soft, #f0f8f7);\n}\n.rcti-mobile-editor-actions {\n  display: none;\n}\n.rcti-editor-state {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 9px;\n  color: var(--rcti-muted);\n  font-size: 13px;\n}\n.rcti-editor-state-pill {\n  border-radius: 999px;\n  padding: 3px 9px;\n  color: var(--rcti-muted);\n  background: var(--rcti-surface-muted);\n  font-size: 12px;\n}\n.rcti-draft-total {\n  display: none;\n}\n.rcti-form-hint {\n  grid-column: 1 / -1;\n  margin: -4px 0 0;\n  color: var(--rcti-muted);\n  font-size: 12px;\n  line-height: 1.5;\n}\n.rcti-notes-field {\n  margin-top: 16px !important;\n}\n.rcti-desktop-items {\n  display: block;\n}\n.rcti-editable-items {\n  display: none;\n}\n.rcti-item-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 14px;\n}\n.rcti-financial-breakdown {\n  display: grid;\n  gap: 12px;\n  margin-top: 20px;\n  border-top: 1px solid var(--rcti-border);\n  padding-top: 18px;\n}\n.rcti-financial-breakdown > div {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 16px;\n  color: var(--rcti-muted);\n  font-size: 13px;\n}\n.rcti-financial-breakdown strong {\n  color: var(--rcti-text);\n  font: 500 13px/1.5 var(--font-family-mono, \"JetBrains Mono\", monospace);\n  text-align: right;\n}\n.rcti-financial-breakdown .rcti-final-total {\n  border-top: 1px solid var(--rcti-border);\n  padding-top: 12px;\n  color: var(--rcti-text);\n  font-weight: 600;\n}\n.rcti-financial-breakdown .rcti-final-total strong {\n  font-weight: 700;\n}\n.rcti-dialog-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  background: rgba(10, 16, 16, 0.45);\n}\n.rcti-leave-dialog {\n  position: relative;\n  width: min(100%, 480px);\n  border: 1px solid var(--rcti-border);\n  border-radius: 14px;\n  padding: 24px;\n  color: var(--rcti-text);\n  background: var(--rcti-surface);\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);\n}\n.rcti-leave-dialog h2 {\n  margin: 0;\n  font-size: 20px;\n}\n.rcti-leave-dialog p {\n  margin: 10px 0 20px;\n  color: var(--rcti-muted);\n  font-size: 14px;\n  line-height: 1.5;\n}\n.rcti-leave-dialog > div {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.rcti-dialog-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: grid;\n  width: 34px;\n  height: 34px;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  color: var(--rcti-muted);\n  background: transparent;\n  cursor: pointer;\n}\n.rcti-dialog-close:hover {\n  background: var(--rcti-surface-muted);\n}\n@media (max-width: 1100px) {\n  .rcti-editor-page .debit-tablet-nav {\n    margin: 0 0 20px;\n  }\n  .rcti-editor-page {\n    padding-top: 22px;\n  }\n  .rcti-editor-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-editor-aside {\n    position: static;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .rcti-summary-card > strong {\n    font-size: 23px;\n  }\n  .rcti-draft-total {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: -6px 0 18px;\n    border: 1px solid var(--rcti-border);\n    border-radius: 10px;\n    padding: 12px 16px;\n    color: var(--rcti-muted);\n    background: var(--rcti-surface);\n    font-size: 13px;\n  }\n  .rcti-draft-total strong {\n    margin-left: auto;\n    color: var(--rcti-text);\n    font: 600 15px/1.4 var(--font-family-mono, \"JetBrains Mono\", monospace);\n  }\n  .rcti-draft-total small {\n    color: var(--rcti-muted);\n  }\n  .rcti-mobile-editor-actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    margin: -6px 0 18px;\n  }\n  .rcti-mobile-editor-actions > button:last-child {\n    grid-column: 1 / -1;\n  }\n  .rcti-header-actions {\n    display: none;\n  }\n  .rcti-desktop-items {\n    display: none;\n  }\n  .rcti-editable-items {\n    display: grid;\n    gap: 12px;\n  }\n  .rcti-editable-item {\n    min-width: 0;\n    border: 1px solid var(--rcti-border);\n    border-radius: 10px;\n    padding: 14px;\n    background: var(--rcti-surface);\n  }\n  .rcti-editable-item-heading {\n    display: flex;\n    min-height: 28px;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--rcti-border);\n    padding-bottom: 8px;\n    color: var(--rcti-text);\n    font-size: 13px;\n  }\n  .rcti-editable-item-heading .MuiGrid-container {\n    width: auto;\n    margin: 0;\n  }\n  .rcti-editable-item-fields {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n    padding-top: 12px;\n  }\n  .rcti-editable-item-fields > div {\n    min-width: 0;\n  }\n  .rcti-editable-item-fields > div > span {\n    display: block;\n    margin-bottom: 4px;\n    color: var(--rcti-muted);\n    font-size: 11px;\n  }\n  .rcti-editable-item-fields .MuiInputBase-root {\n    width: 100% !important;\n    min-width: 0 !important;\n  }\n  .rcti-editable-item-fields .MuiGrid-container,\n  .rcti-editable-item-fields .MuiGrid-item {\n    width: 100%;\n    min-width: 0;\n    margin: 0;\n    padding: 0;\n  }\n  .rcti-editable-item-fields .MuiInputBase-input {\n    box-sizing: border-box;\n    min-width: 0 !important;\n  }\n  .rcti-editable-item-fields > div:first-child,\n  .rcti-editable-item-fields > div:nth-child(2) {\n    grid-column: 1 / -1;\n  }\n  .rcti-list-shell .debit-tablet-nav {\n    margin: 0 32px;\n  }\n  .rcti-list-page {\n    padding-top: 24px;\n    gap: 20px;\n  }\n}\n@media (max-width: 700px) {\n  .rcti-editor-page .debit-tablet-nav {\n    margin: 0 0 14px;\n  }\n  .rcti-editor-page {\n    padding-top: 18px;\n  }\n  .rcti-draft-total {\n    flex-wrap: wrap;\n    gap: 6px 10px;\n    padding: 10px 12px;\n  }\n  .rcti-draft-total span {\n    flex: 1 1 100%;\n  }\n  .rcti-draft-total strong {\n    margin-left: 0;\n  }\n  .rcti-mobile-editor-actions {\n    grid-template-columns: 1fr 1fr;\n  }\n  .rcti-mobile-editor-actions > button {\n    min-width: 0;\n    padding-inline: 8px;\n    font-size: 12px;\n  }\n  .rcti-editor-aside {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-editable-item-fields {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-editable-item-fields > div:first-child,\n  .rcti-editable-item-fields > div:nth-child(2) {\n    grid-column: auto;\n  }\n  .rcti-list-shell .debit-tablet-nav {\n    margin: 0 16px;\n  }\n  .rcti-list-page {\n    padding-top: 16px;\n    gap: 16px;\n  }\n  .rcti-leave-dialog {\n    padding: 22px 16px 16px;\n  }\n  .rcti-leave-dialog > div {\n    justify-content: stretch;\n  }\n  .rcti-leave-dialog > div > button {\n    flex: 1 1 auto;\n  }\n}\n/* Desktop listing refinements from Figma 1261:68924 */\n.rcti-list-heading h1 {\n  font-size: 32px;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n  font-weight: 600;\n}\n.rcti-list-heading > div:first-child > p {\n  margin-top: 4px;\n  line-height: 21.7px;\n}\n.rcti-list-context {\n  margin-top: 0;\n  line-height: 19px;\n}\n.rcti-financial-card {\n  min-height: 154px;\n}\n.rcti-financial-card h2 {\n  font-size: 16px;\n  line-height: 22.4px;\n  font-weight: 500;\n  letter-spacing: -0.08px;\n}\n.rcti-financial-card > strong {\n  font-size: 20px;\n  line-height: 24px;\n}\n.rcti-financial-card > p,\n.rcti-summary-note {\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.rcti-list-search {\n  flex: 0 0 420px;\n  width: 420px;\n}\n.rcti-filter-select {\n  flex: 0 0 126px;\n  width: 126px;\n}\n.rcti-filter-select select {\n  min-width: 0;\n  font-size: 13px;\n}\n.rcti-due-select {\n  flex-basis: 169px;\n  width: 169px;\n}\n.rcti-due-select select {\n  min-width: 0;\n}\n.rcti-register-table .rdt_TableCol--selectable,\n.rcti-register-table .rdt_TableCell--selectable {\n  flex: 0 0 40px !important;\n  width: 40px !important;\n  min-width: 40px !important;\n}\n.rcti-register-table .rdt_TableHeadRow {\n  min-height: 44px;\n}\n.rcti-register-table .rdt_TableCol {\n  font-size: 13px;\n}\n.rcti-register-table .rdt_TableCell {\n  font-size: 14px;\n}\n.rcti-status-overdue,\n.rcti-status-overdue-payable {\n  color: var(--danger-text, #a3301f);\n  background: var(--danger-soft, #fef2f1);\n}\n.rcti-planned-date {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  line-height: 18px;\n}\n.rcti-planned-date small {\n  color: var(--rcti-muted);\n  font-size: 12px;\n}\n.rcti-table-card {\n  margin-top: 0;\n  overflow: visible;\n}\n.rcti-table-card .quotation-table-context {\n  min-height: 48px;\n}\n.rcti-table-card .quotation-table-scroll {\n  overflow-x: auto;\n}\n.rcti-table-card table {\n  min-width: 1120px;\n  table-layout: auto;\n}\n.rcti-table-card th {\n  padding-inline: 16px;\n  font-size: 13px;\n  text-align: left;\n}\n.rcti-table-card td {\n  padding: 8px 16px;\n  text-align: left;\n}\n.rcti-table-card th.rcti-col-select,\n.rcti-table-card td.rcti-col-select {\n  width: 48px;\n  padding: 0;\n  text-align: center;\n}\n.rcti-table-card th.rcti-col-actions,\n.rcti-table-card td.rcti-col-actions {\n  padding-inline: 16px;\n  text-align: right;\n}\n.rcti-table-card th.rcti-heading-money {\n  text-align: right;\n}\n.rcti-table-card .rcti-table-supplier {\n  max-width: 28ch;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n.rcti-table-card .rcti-table-money {\n  text-align: right;\n}\n.rcti-sort-heading {\n  border: 0;\n  padding: 0;\n  color: inherit;\n  background: transparent;\n  font: inherit;\n  text-align: inherit;\n  cursor: pointer;\n}\n.rcti-sort-heading:focus-visible {\n  outline: 2px solid var(--interactive-default);\n  outline-offset: 3px;\n  border-radius: 2px;\n}\n.rcti-row-actions {\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n.rcti-table-card .rcti-col-actions .rcti-row-actions {\n  justify-content: flex-end;\n}\n.rcti-row-actions .quotation-action-menu {\n  top: calc(100% + 4px);\n  right: 0;\n  z-index: 20;\n}\n.rcti-planned-date {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  line-height: 17px;\n}\n.rcti-planned-date small {\n  font-size: 11px;\n}\n.rcti-table-card .quotation-pagination {\n  flex: 0 0 52px;\n}\n.rcti-table-card .rcti-register-table .rcti-status-pill {\n  min-height: 20px;\n  padding-inline: 8px;\n}\n.rcti-flow-shell.dark .rcti-table-card .quotation-table-card,\n.rcti-flow-shell.dark .rcti-table-card .quotation-pagination {\n  color: var(--rcti-text);\n}\n.rcti-flow-shell.dark .rcti-table-card .quotation-action-menu {\n  border-color: var(--border-default, #3a3f47);\n  background: var(--surface-elevated, #25282e);\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.35), 0px 1px 2px rgba(0, 0, 0, 0.2);\n}\n.rcti-table-card tbody tr,\n.rcti-register-mobile-card {\n  cursor: pointer;\n}\n.rcti-table-card tbody tr:hover,\n.rcti-register-mobile-card:hover {\n  background: var(--rcti-surface-muted);\n}\n.rcti-contact-link {\n  color: var(--rcti-accent);\n  font: inherit;\n  text-decoration: none;\n  text-underline-offset: 2px;\n}\n.rcti-contact-link:hover {\n  text-decoration: underline;\n  color: #0f766e;\n}\n.rcti-contact-link:focus-visible {\n  border-radius: 2px;\n  outline: 2px solid var(--rcti-accent);\n  outline-offset: 2px;\n}\n.rcti-flow-shell.dark .rcti-table-card .quotation-menu-item {\n  color: var(--rcti-text);\n}\n.rcti-flow-shell.dark .rcti-table-card .quotation-menu-item:hover {\n  background: var(--surface-secondary);\n}\n@media (max-width: 600px) {\n  .rcti-table-card {\n    margin-top: 16px;\n    border-radius: 10px;\n  }\n  .rcti-table-card .quotation-table-context {\n    height: 44px;\n    padding-inline: 12px;\n  }\n  .rcti-table-card .quotation-table-context strong {\n    font-size: 12px;\n  }\n  .rcti-table-card .quotation-table-context span {\n    display: none;\n  }\n  .rcti-table-card .quotation-pagination {\n    height: 44px;\n    padding-inline: 12px;\n  }\n  .rcti-table-card .quotation-pagination span {\n    font-size: 10px;\n  }\n  .rcti-table-card .quotation-pagination-btns {\n    gap: 6px;\n  }\n  .rcti-table-card .quotation-pagination-btns button {\n    width: 30px;\n    height: 30px;\n  }\n}\n@media (max-width: 1100px) {\n  .rcti-list-heading h1 {\n    font-size: 28px;\n    line-height: 35px;\n    letter-spacing: -0.42px;\n  }\n  .rcti-list-search {\n    flex: 1 1 100%;\n    width: 100%;\n  }\n  .rcti-filter-select,\n  .rcti-due-select {\n    flex: 0 1 auto;\n    width: auto;\n  }\n}\n\n/* RCTI editor geometry and responsive variants from Figma 1261:70442–70970. */\n.rcti-editor-page {\n  padding: 32px 32px 48px;\n}\n.rcti-editor-page .rcti-back {\n  margin-bottom: 16px;\n}\n.rcti-editor-page .rcti-page-heading {\n  margin-bottom: 0;\n}\n.rcti-editor-page .rcti-page-heading h1 {\n  font-size: 24px;\n  line-height: 30px;\n  letter-spacing: -0.36px;\n  font-weight: 600;\n}\n.rcti-editor-page .rcti-business-meta {\n  margin: 16px 0 0;\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.rcti-editor-page .rcti-notice {\n  margin: 16px 0 24px;\n  border: 0;\n  border-radius: 10px;\n  padding: 16px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n.rcti-editor-page .rcti-notice > div {\n  gap: 4px;\n}\n.rcti-editor-page .rcti-notice strong {\n  font-size: 13px;\n  line-height: 16.9px;\n  font-weight: 500;\n}\n.rcti-editor-page .rcti-notice span {\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.rcti-editor-layout {\n  grid-template-columns: minmax(0, 776fr) minmax(280px, 320fr);\n  gap: 24px;\n}\n.rcti-editor-main-column {\n  gap: 24px;\n}\n.rcti-editor-page .rcti-editor-aside {\n  gap: 24px;\n}\n.rcti-editor-page .rcti-section-card,\n.rcti-editor-page .rcti-summary-card {\n  border-radius: 14px;\n  padding: 24px;\n  box-shadow: 0 1px 2px rgb(14 26 32 / 6%);\n}\n.rcti-editor-page .rcti-section-heading h2,\n.rcti-editor-page .rcti-summary-card h2 {\n  font-size: 16px;\n  line-height: 22.4px;\n  letter-spacing: -0.08px;\n  font-weight: 500;\n}\n.rcti-editor-page .rcti-section-heading {\n  margin-bottom: 24px;\n}\n.rcti-editor-page .rcti-section-heading:has(p) {\n  margin-bottom: 20px;\n}\n.rcti-editor-page .rcti-section-heading p {\n  margin-top: 24px;\n}\n.rcti-editor-page .rcti-section-heading p,\n.rcti-editor-page .rcti-delivery-card p,\n.rcti-editor-page .rcti-form-hint {\n  font-size: 13px;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n.rcti-editor-page .rcti-editor-state {\n  margin-top: 8px;\n  gap: 12px;\n}\n.rcti-editor-page .rcti-editor-state-pill {\n  padding: 4px 6px;\n  line-height: 14px;\n}\n.rcti-editor-page .rcti-summary-card > strong {\n  font: 700 20px/24px var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.rcti-editor-page .rcti-summary-card > span {\n  line-height: 18.2px;\n}\n.rcti-editor-page .rcti-editor-total-card {\n  min-height: 154px;\n  gap: 24px;\n}\n.rcti-editor-page .rcti-editor-total-card > strong {\n  margin-top: 0;\n}\n.rcti-editor-page .rcti-breakdown-card dl {\n  gap: 16px;\n}\n.rcti-editor-page .rcti-breakdown-card .rcti-aside-total-row {\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n  padding-top: 12px;\n  color: var(--text-primary, #142624);\n  font-weight: 600;\n}\n.rcti-editor-page .rcti-breakdown-card p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  line-height: 18px;\n}\n.rcti-editor-page .rcti-draft-total-heading {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  color: var(--text-primary, #142624);\n  font-size: 16px;\n  font-weight: 500;\n}\n.rcti-editor-page .rcti-draft-total-heading svg {\n  color: var(--interactive-default, #0f766e);\n}\n.rcti-editor-page .rcti-field .MuiFormControl-root {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.rcti-editor-page .rcti-field .MuiInputLabel-root {\n  position: static;\n  max-width: none;\n  transform: none;\n  overflow: visible;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n.rcti-editor-page .rcti-field .MuiInputBase-root:not(.MuiInputBase-multiline) {\n  min-height: 40px;\n  border-radius: 10px;\n}\n.rcti-editor-page .rcti-field .MuiInputBase-input {\n  box-sizing: border-box;\n  padding-block: 9px;\n  font-size: 13px;\n  line-height: 20px;\n}\n.rcti-editor-page .rcti-field .MuiInputBase-input::placeholder {\n  color: var(--text-tertiary, #6b7b78);\n  opacity: 1;\n}\n.rcti-editor-page .rcti-field .MuiInputBase-root.Mui-disabled {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.rcti-editor-page\n  .rcti-field\n  .MuiInputBase-root.Mui-disabled\n  .MuiInputBase-input {\n  -webkit-text-fill-color: var(--text-secondary, #506360);\n}\n.rcti-editor-page .rcti-notes-field {\n  margin-top: 0 !important;\n}\n.rcti-editor-page .rcti-pricing-basis {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  line-height: 16.9px;\n}\n.rcti-editor-page .rcti-pricing-basis .MuiFormControl-root {\n  width: 144px;\n}\n.rcti-editor-page .rcti-pricing-basis .MuiInputBase-root {\n  height: 40px;\n  border-radius: 10px;\n}\n.rcti-editor-page .rcti-pricing-basis .MuiSelect-select {\n  padding-block: 9px;\n  font-size: 13px;\n}\n.rcti-editor-page .rcti-new-supplier-button {\n  justify-content: flex-start;\n  width: fit-content;\n  border-color: transparent;\n  color: var(--interactive-default, #0f766e);\n  background: transparent;\n}\n.rcti-editor-page .rcti-new-supplier-button:hover {\n  background: var(--interactive-soft, #f0f8f7);\n}\n.rcti-editor-page\n  .MuiOutlinedInput-root.Mui-focused\n  .MuiOutlinedInput-notchedOutline {\n  border-color: var(--focus-ring, #0f766e);\n  border-width: 1px;\n}\n.rcti-editor-page .MuiInputLabel-root.Mui-focused {\n  color: var(--interactive-default, #0f766e);\n}\n.rcti-editor-page .rcti-summary-card dl {\n  gap: 14px;\n}\n.rcti-editor-page .rcti-summary-card dt,\n.rcti-editor-page .rcti-summary-card dd {\n  font-size: 13px;\n  line-height: 18.2px;\n}\n.rcti-editor-page .rcti-header-actions {\n  gap: 12px;\n}\n.rcti-editor-page .rcti-primary-button,\n.rcti-editor-page .rcti-secondary-button {\n  min-height: 40px;\n  border-radius: 10px;\n}\n@media (max-width: 1100px) {\n  .rcti-editor-page {\n    padding: 20px 24px 40px;\n  }\n  .rcti-editor-page .rcti-page-heading {\n    display: block;\n    margin-bottom: 0;\n  }\n  .rcti-editor-page .rcti-editor-state {\n    margin-top: 12px;\n  }\n  .rcti-editor-page .rcti-business-meta {\n    margin-top: 16px;\n  }\n  .rcti-editor-page .rcti-mobile-editor-actions {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px 12px;\n    margin: 24px 0 20px;\n  }\n  .rcti-editor-page .rcti-mobile-editor-actions > button {\n    min-height: 44px;\n  }\n  .rcti-editor-page .rcti-mobile-editor-actions > button:last-child {\n    grid-column: 1 / -1;\n  }\n  .rcti-editor-page .rcti-fields-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 16px;\n  }\n  .rcti-editor-page .rcti-pricing-basis {\n    align-items: stretch;\n    flex-direction: column;\n    gap: 6px;\n  }\n  .rcti-editor-page .rcti-pricing-basis .MuiFormControl-root,\n  .rcti-editor-page .rcti-new-supplier-button {\n    width: 100%;\n  }\n  .rcti-editor-page .rcti-new-supplier-button {\n    justify-content: center;\n  }\n  .rcti-editor-page .rcti-field-wide {\n    grid-column: auto;\n  }\n  .rcti-editor-layout {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 24px;\n  }\n  .rcti-editor-aside {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-editor-page .rcti-editable-item-fields {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-editor-page .rcti-editable-item-fields > div:first-child,\n  .rcti-editor-page .rcti-editable-item-fields > div:nth-child(2) {\n    grid-column: auto;\n  }\n  .rcti-editor-page .rcti-item-actions {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n  .rcti-editor-page .rcti-item-actions > button,\n  .rcti-editor-page .rcti-section-card > .MuiButton-root {\n    width: 100%;\n    min-height: 44px;\n  }\n  .rcti-editor-page .rcti-draft-total {\n    min-height: 122px;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 8px;\n    margin: 0 0 20px;\n    border-radius: 14px;\n    padding: 20px;\n    box-shadow: 0 1px 2px rgb(14 26 32 / 6%);\n  }\n  .rcti-editor-page .rcti-draft-total strong {\n    margin-left: 0;\n    font-size: 20px;\n    line-height: 24px;\n  }\n  .rcti-editor-page .rcti-draft-total small {\n    font-size: 13px;\n    line-height: 18.2px;\n  }\n  .rcti-editor-page .rcti-summary-card {\n    padding: 16px;\n  }\n  .rcti-editor-page .rcti-editor-aside {\n    gap: 24px;\n  }\n  .rcti-editor-page .rcti-editor-total-card {\n    display: none;\n  }\n  .rcti-editor-page .rcti-draft-total {\n    display: flex;\n  }\n  .rcti-editor-page .rcti-delivery-card > button {\n    width: 100%;\n    min-height: 44px;\n  }\n}\n@media (max-width: 700px) {\n  .rcti-editor-page {\n    padding: 20px 16px 32px;\n  }\n  .rcti-editor-page .rcti-page-heading h1 {\n    font-size: 24px;\n    line-height: 30px;\n  }\n  .rcti-editor-page .rcti-editor-state {\n    margin-top: 12px;\n  }\n  .rcti-editor-page .rcti-notice {\n    padding: 16px;\n  }\n  .rcti-editor-page .rcti-section-card {\n    padding: 16px;\n    border-radius: 14px;\n  }\n  .rcti-editor-page .rcti-mobile-editor-actions {\n    margin-top: 24px;\n  }\n  .rcti-editor-page .rcti-draft-total {\n    min-height: 122px;\n    padding: 16px;\n  }\n}\n.rcti-editor-page .rcti-desktop-items {\n  display: none !important;\n}\n.rcti-editor-page .rcti-item-column-headings,\n.rcti-editor-page .rcti-editable-item-fields {\n  display: grid;\n  grid-template-columns: minmax(0, 284px) 64px 116px 100px 132px;\n  gap: 8px;\n}\n.rcti-editor-page .rcti-item-column-headings {\n  min-height: 44px;\n  align-items: center;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 6px 6px 0 0;\n  padding: 0 16px;\n  color: var(--text-secondary, #506360);\n  background: var(--surface-secondary, #f4f7f7);\n  font-size: 11px;\n  line-height: 14.3px;\n  font-weight: 500;\n}\n.rcti-editor-page .rcti-item-column-headings span:last-child {\n  text-align: right;\n}\n.rcti-editor-page .rcti-editable-items {\n  display: grid;\n  gap: 0;\n}\n.rcti-editor-page .rcti-editable-item {\n  min-width: 0;\n  border: 0;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 0;\n  padding: 12px 0;\n  background: transparent;\n}\n.rcti-editor-page .rcti-item-catalogue,\n.rcti-editor-page .rcti-item-catalogue > div {\n  min-width: 0;\n}\n.rcti-editor-page .rcti-item-catalogue {\n  margin-bottom: 12px;\n}\n.rcti-editor-page .rcti-item-catalogue > div > span,\n.rcti-editor-page .rcti-editable-item-fields > div > span {\n  display: none;\n}\n.rcti-editor-page .rcti-item-catalogue .MuiInputBase-root {\n  box-sizing: border-box;\n  width: 100% !important;\n  min-height: 40px;\n  margin-top: 0 !important;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  padding-inline: 12px;\n  background: var(--surface-primary, #fff);\n}\n.rcti-editor-page .rcti-editable-item-fields {\n  align-items: start;\n}\n.rcti-editor-page .rcti-editable-item-fields > div {\n  min-width: 0;\n}\n.rcti-editor-page .rcti-editable-item-fields .MuiGrid-container,\n.rcti-editor-page .rcti-editable-item-fields .MuiGrid-item {\n  width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n}\n.rcti-editor-page .rcti-editable-item-fields .MuiInputBase-root {\n  box-sizing: border-box;\n  width: 100% !important;\n  min-width: 0 !important;\n  min-height: 40px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  padding-inline: 10px;\n  color: var(--text-primary, #142624);\n  background: var(--surface-primary, #fff);\n}\n.rcti-editor-page .rcti-editable-item-fields .MuiInput-root::before,\n.rcti-editor-page .rcti-editable-item-fields .MuiInput-root::after {\n  display: none;\n}\n.rcti-editor-page .rcti-editable-item-fields .MuiInputBase-input {\n  box-sizing: border-box;\n  min-width: 0 !important;\n  padding: 9px 0;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  line-height: 20px;\n}\n.rcti-editor-page .rcti-editable-item-fields .MuiInputBase-input::placeholder {\n  color: var(--text-tertiary, #6b7b78);\n  opacity: 1;\n}\n.rcti-editor-page .rcti-editable-item-fields .MuiInputBase-root.Mui-disabled {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.rcti-editor-page .rcti-editable-item-fields > div:first-child {\n  grid-column: 1;\n}\n.rcti-editor-page .rcti-discount-fields {\n  display: flex;\n  grid-column: 1 / -1;\n  gap: 8px;\n}\n.rcti-editor-page .rcti-discount-fields > div {\n  width: 148px;\n  min-width: 0;\n}\n.rcti-editor-page .rcti-discount-fields > div > span {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  line-height: 16.9px;\n  font-weight: 500;\n}\n.rcti-editor-page .rcti-item-remove {\n  grid-column: 1 / -1;\n}\n.rcti-editor-page .rcti-item-remove .MuiButton-root {\n  width: 100%;\n  min-height: 44px;\n  border-radius: 10px;\n}\n.rcti-editor-page .rcti-upload-hint > span {\n  display: grid;\n  gap: 4px;\n}\n.rcti-editor-page .rcti-upload-hint strong {\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n  font-weight: 500;\n}\n.rcti-editor-page .rcti-upload-hint small {\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n  line-height: 18px;\n}\n.rcti-editor-page .MuiOutlinedInput-notchedOutline {\n  border: 1px solid var(--border-default, #cdd6d4) !important;\n}\n.rcti-editor-page\n  .MuiOutlinedInput-root.Mui-focused\n  .MuiOutlinedInput-notchedOutline {\n  border-color: var(--focus-ring, #0f766e) !important;\n  border-width: 2px !important;\n}\n.rcti-editor-page .MuiInputLabel-root:not(.Mui-focused) {\n  color: var(--text-primary, #142624) !important;\n}\n.rcti-editor-page .MuiInput-root::before {\n  border-bottom: 1px solid var(--border-default, #cdd6d4) !important;\n}\n.rcti-editor-page\n  .MuiInput-root:hover:not(.Mui-disabled, .Mui-focused)::before {\n  border-bottom: 1px solid var(--border-strong, #8b9996) !important;\n}\n.rcti-editor-page .MuiInput-root.Mui-focused::after {\n  border-bottom: 2px solid var(--focus-ring, #0f766e) !important;\n}\n.rcti-editor-page .rcti-item-column-headings,\n.rcti-editor-page .rcti-editable-item-fields {\n  grid-template-columns:\n    minmax(0, 2.8fr)\n    minmax(48px, 0.62fr)\n    minmax(82px, 1.05fr)\n    minmax(66px, 0.84fr)\n    minmax(94px, 1.15fr);\n}\n.rcti-editor-page .rcti-item-catalogue .MuiAutocomplete-root,\n.rcti-editor-page .rcti-item-catalogue .MuiFormControl-root,\n.rcti-editor-page\n  .rcti-editable-item-fields\n  > div:not(.rcti-discount-fields):not(.rcti-item-remove)\n  .MuiFormControl-root,\n.rcti-editor-page\n  .rcti-editable-item-fields\n  > div:not(.rcti-discount-fields):not(.rcti-item-remove)\n  .MuiGrid-container,\n.rcti-editor-page\n  .rcti-editable-item-fields\n  > div:not(.rcti-discount-fields):not(.rcti-item-remove)\n  .MuiGrid-item,\n.rcti-editor-page\n  .rcti-editable-item-fields\n  > div:not(.rcti-discount-fields):not(.rcti-item-remove)\n  .MuiTextField-root {\n  box-sizing: border-box;\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  margin-inline: 0 !important;\n}\n.rcti-editor-page .rcti-item-catalogue .MuiInputBase-root,\n.rcti-editor-page\n  .rcti-editable-item-fields\n  > div:not(.rcti-discount-fields):not(.rcti-item-remove)\n  .MuiInputBase-root {\n  box-sizing: border-box;\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n}\n.rcti-editor-page\n  .rcti-editable-item-fields\n  > div:not(.rcti-discount-fields):not(.rcti-item-remove)\n  .MuiInputBase-input {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0 !important;\n}\n@media (max-width: 1100px) {\n  .rcti-editor-page .rcti-item-column-headings {\n    display: none;\n  }\n  .rcti-editor-page\n    .rcti-editable-item-fields\n    > div:first-child\n    .MuiInputBase-root {\n    min-height: 120px;\n    align-items: flex-start;\n  }\n  .rcti-editor-page .rcti-item-catalogue > div > span,\n  .rcti-editor-page .rcti-editable-item-fields > div > span {\n    display: block;\n  }\n  .rcti-editor-page .rcti-item-catalogue > div > span,\n  .rcti-editor-page .rcti-editable-item-fields > div > span {\n    margin-bottom: 6px;\n    color: var(--text-primary, #142624);\n    font-size: 13px;\n    line-height: 16.9px;\n    font-weight: 500;\n  }\n  .rcti-editor-page .rcti-editable-item-fields > div:first-child {\n    grid-column: auto;\n  }\n  .rcti-editor-page .rcti-discount-fields {\n    display: contents;\n  }\n  .rcti-editor-page .rcti-discount-fields > div {\n    width: auto;\n    min-width: 0;\n  }\n  .rcti-editor-page .rcti-item-remove {\n    grid-column: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
